// ----------------------------------------------------------------------

import { common } from '@mui/material/colors';
import { globalDashboardEs } from './modules/globalDashboard.es';
import { privacyEs } from './modules/privacy.es';
import { analyticsEs } from './modules/analytics.es';
import { stripeConnectEs } from './modules/stripeConnect.es';

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to instadrinkpro@gmail.com.

// ----------------------------------------------------------------------

const es = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hola`,
    description: `¿Necesitas ayuda? \n Por favor, consulta nuestra documentación.`,
    documentation: `documentación`,
  },
  app: 'Aplicación',
  user: 'Usuario',
  list: 'Lista',
  edit: 'Editar',
  shop: 'Tienda',
  blog: 'Blog',
  post: 'Publicación',
  mail: 'Correo',
  chat: 'Chat',
  cards: 'Tarjetas',
  posts: 'Publicaciones',
  create: 'Crear',
  kanban: 'Kanban',
  general: 'general',
  banking: 'Banca',
  booking: 'Reserva',
  profile: 'Perfil',
  account: 'Cuenta',
  product: 'Producto',
  invoice: 'Factura',
  details: 'Detalles',
  checkout: 'Pagar',
  calendar: 'Calendario',
  analytics: 'Analítica',
  ecommerce: 'Comercio electrónico',
  management: 'Gestión',
  menu_level_1: 'Menú nivel 1',
  menu_level_2: 'Menú nivel 2',
  menu_level_3: 'Menú nivel 3',
  item_disabled: 'Elemento deshabilitado',
  item_label: 'Etiqueta del elemento',
  item_caption: 'Descripción del elemento',
  description: 'Descripción',
  other_cases: 'Otros casos',
  item_by_roles: 'Elemento por roles',
  only_admin_can_see_this_item: 'Solo el administrador puede ver este elemento',
  create_event: 'Crear un evento',
  label_Rows_Per_Page: 'Filas por página',
  created_At: 'Creado el',
  location: 'Ubicación',
  title: 'Título',
  events: 'Eventos',
  archived: 'Archivado',
  canceled: 'Cancelado',
  Start_Date: 'Fecha de inicio del evento',
  End_Date: 'Fecha de finalización del evento',
  organisation: 'Organización',
  organisations: 'Organizaciones',
  published_events: 'Eventos Publicados',
  Add_event: 'Agregar Evento',
  event_name: 'Nombre del Evento',
  summary: 'Resumen',
  cancel: 'Cancelar',
  cancel_successful: 'Invitación cancelada',
  cancel_failed: 'No se pudo cancelar la invitación',
  add: 'Agregar',
  view_event: 'Ver Evento',
  event_title: 'Título del Evento',
  cover: 'Portada',
  cover_image: 'Imagen de Portada',
  category: 'Categoría',
  sub_category: 'Subcategoría',
  status: 'Estado',
  listed: 'Evento Público',
  listed_tooltip:
    'Cuando está activado, su evento será visible públicamente y cualquiera podrá buscarlo en el listado de eventos',
  online_event: 'Evento en Línea',
  tags: 'Etiquetas',
  address: 'Dirección',
  city: 'Ciudad',
  capacity: 'Capacidad',
  save: 'Guardar',
  Start_Time: 'Hora de Inicio del evento',
  End_Time: 'Hora de Finalización del evento',
  timezone: 'Zona Horaria',
  Save_Changes: 'Guardar Cambios',
  Quantity: 'Cantidad',
  Initial_Quantity: 'Cantidad Disponible',
  Max_Quantity: 'Máximo por Pedido',
  price: 'Precio',
  free: 'Gratis',
  Sell_Time_Limit: 'Límite de Venta',
  delete: 'Eliminar',
  Edit: 'Editar',
  Add_Ticket: 'Agregar Tiquete',
  Sell_limit: 'Límite de Venta',
  start: 'Comienzo',
  end: 'Fin',
  Access_Time_Limit: 'Hora de acceso al evento',
  Price_Quantity: 'Precio y Cantidad',
  Access_limit: 'Límite de Acceso',
  name: 'Nombre',
  Your_event_is_already_published_on_this_link: 'Tu evento ya está publicado en este enlace',
  archive: 'Archivar',
  Event_Dashboard: 'Panel de Control del Evento',
  Preview_Event: 'Vista Previa del Evento',
  publish: 'Publicar',
  Email_Message: 'Texto del correo electrónico enviado a los participantes de su evento',
  Ticket_Message: 'Mensaje del Tiquete',
  include: 'Incluir',
  required: 'Requerido',
  Gender: 'Género',
  Birthday: 'Fecha de Nacimiento',
  HomePhone: 'Teléfono de Casa',
  yourEventIs: 'Tu evento es',
  date: 'Fecha',
  events_catering: 'Eventos y catering',
  events_catering_description:
    'ID es una plataforma que permite a sus clientes comprar entradas para asistir a sus eventos, así como pedir su comida y bebida digitalmente en su establecimiento.',
  create_digital_exp: 'Cree su experiencia digital',
  create_digital_exp_description:
    'Los clientes interactúan con su marca, a su manera; usted controla su presencia digital para maximizar los ingresos y la rentabilidad.',
  digital_ticketing: 'VENTA DE ENTRADAS DIGITAL',
  digital_ticketing_title: 'Añada sus eventos y venda entradas en nuestra plataforma.',
  digital_ticketing_description:
    'Cada uno de tus clientes que desee participar puede hacer clic en un enlace o escanear un código QR en el folleto digital o físico de tu evento; esto les dirigirá a la plataforma ID donde podrán seleccionar y pagar su entrada.',
  more_questions: '¿Aún tiene preguntas?',
  more_questions_description: 'Describa su caso para recibir el asesoramiento más preciso.',
  who_are_we: {
    who: '¿',
    are: 'Quiénes',
    we: 'somos',
    work: 'Trabajamos juntos para',
    futur: 'un futuro mejor en eventos y la restauración',
  },
  what_is_id: {
    title: '¿Qué es ID?',
    description:
      'ID es una plataforma que permite a tus clientes comprar entradas para asistir a tus eventos, así como pedir su comida y bebida digitalmente en tu establecimiento.',
  },
  about: {
    vision:
      'Nuestra visión: ofrecer la plataforma perfecta para un futuro mejor en eventos y catering.',
    dream_team: 'EQUIPO DE SUEÑOS',
    dream_team_description:
      'ID le proporcionará asistencia si tiene algún problema. Nuestro equipo de asistencia responderá. Un buen equipo es la clave. En el plazo de un día, y también disponemos de documentación detallada.',
  },
  testimonials: {
    title: 'TESTIMONIOS',
    who: '¿A quién le gusta ',
    service: ' nuestro servicio?',
    description:
      'Nuestro objetivo es crear la plataforma perfecta que satisfaga a todos nuestros clientes de eventos y catering. Por eso trabajamos constantemente en nuestros servicios para mejorarlos cada día escuchando las valiosas sugerencias que nuestros usuarios comparten con nosotros.',
  },

  Min_Quantity: 'Mínimo por pedido',
  save_continue: 'Guardar y continuar',
  continue_later: 'No guardar y continuar más tarde',
  Link_to_buy_tickets_for_your_event: 'Enlace para comprar boletos para tu evento',
  back: 'Atrás',
  Complete_the_details_of_the_event_to_be_able_to_publish_it:
    'Completa los detalles del evento para poder publicarlo',
  publish_the_event: 'Publicar el evento',
  view: 'Ver',
  ready_events: 'Eventos listos',
  drafted_events: 'Eventos borrador',
  archived_events: 'Eventos archivados',
  canceled_events: 'Eventos cancelados',
  no_events: 'Sin eventos',
  my_events: 'Mis promo eventos',
  total_sold: 'Los ingresos totales',
  sold_quantity: 'Número de entradas vendidas',
  send_batch_emails: 'Enviar correos masivos',
  event_link: 'Enlace del evento',
  sale_date: 'Fecha de venta',
  validated: 'Validado',
  confirmed: 'Confirmado',
  reimbursed: 'Reembolsado',
  About: 'Acerca de',
  Name: 'Nombre',
  promoters: 'Promoters',
  add_promoter: 'Agregar Promoter',
  choose_promoter: 'Elegir Promoter',
  remove: 'Eliminar',
  min_followers: 'Seguidores Mínimos',
  Dashboard: 'Tablero de Control',
  General: 'General',
  Preview: 'Vista Previa',
  required_information: 'Información Requerida',
  promo_code: 'Códigos de Promoción',
  overview: 'Resumen',
  preview_your_event: 'Vista Previa de tu Evento',
  Owner: 'Dueño',
  create_org: 'Crear una organización',
  Account: 'Cuenta',
  account_settings: 'Configuración de Cuenta',
  Allowed_format: 'Formatos permitidos',
  max_size: 'tamaño máximo de',
  billing: 'facturación',
  Email_Address: 'Dirección de Correo Electrónico',
  Phone_Number: 'Número de Teléfono',
  Country: 'País',
  State_Region: 'Estado/Región',
  Zip_Code: 'Código Postal',
  discount: 'Descuento',
  maximum_number_of_sold_tickets: 'Número máximo de boletos vendidos',
  Featured_tickets: 'Boletos Destacados',
  No_promo_code_available: 'No hay códigos de promoción disponibles',
  add_promo_code: 'Agregar código de promoción',
  This_code_is_already_used: '¡Este código ya está en uso!',
  discount_amount: 'Monto del Descuento',
  advanced_options: 'Opciones Avanzadas',
  all_tickets: 'Todos los boletos',
  specific_tickets: 'Boletos específicos',
  Legal_info: 'Información Legal',
  Followers: 'Seguidores',
  Total_events: 'Total de Eventos',
  Recommended: 'Recomendado',
  company_name: 'Nombre de la Compañía',
  company_number: 'Número de Compañía',
  Website: 'Sitio Web',
  Cover: 'Portada',
  add_organisation: 'Agregar organización',
  create_user: 'Crear usuario',
  users: 'usuarios',
  firstname: 'Nombre',
  lastname: 'Apellido',
  role: 'Rol',
  access: 'Acceso',
  events_permissions: 'Permisos de Eventos',
  organisations_permissions: 'Permisos de Organizaciones',
  Yes: 'Sí',
  No: 'No',
  Permissions: 'Permisos',
  Editing: 'Edición',
  Roles: 'Roles',
  Search: 'Buscar',
  Event_stats: 'Estadísticas del Evento',
  sales: 'ventas',
  Number_of_purchase: 'Número de compras',
  Link: 'Enlace',
  sold: 'vendido',
  available: 'disponible',
  Tickets_status: 'Estado de los Boletos',
  There_is_no_tickets_status_for_this_event: 'No hay estado de boletos para este evento',
  promoter: 'PromoBooster',
  invite_user: 'Invitar usuario',
  published: 'Publicado',
  ready: 'Listo',
  draft: 'Borrador',
  initial: 'inicial',
  upcoming: 'próximo',
  ongoing: 'en curso',
  past: 'pasado',
  Organisation: 'Organización',
  Bio: 'Biografía',
  Type: 'Tipo',
  Evenementiel: 'Eventos',
  Restaurant: 'Restaurante',
  Email: 'Correo electrónico',
  Drop_or_Select_file: 'Dejar o seleccionar un archivo',
  Rajoutez_une_image_de_couverture_pour_votre_événement:
    'Agrega una imagen de portada para tu evento',
  Upload_photo: 'Subir foto',
  Update_photo: 'Actualizar foto',
  organisation_users: 'Usuarios de la organización',
  Agent_liés_à_lorganisation: 'Agentes relacionados con la organización',
  Agents_en_attente_de_confirmation: 'Agentes en espera de confirmación',
  Instadrink_admin: 'Administrador de I.D',
  create_role: 'Crear un rol',
  Predefined_roles: 'Roles predefinidos',
  Custom_roles: 'Roles personalizados',
  Agents: 'Agentes',
  Organizer: 'Organizador',
  Bouncer: 'Bravucón',
  Ambassador: 'Embajador',
  promotion_groups: 'grupos de promoción',
  Dates: 'fechas',
  Tickets: 'Entradas',
  Information: 'Información',
  Messages: 'Mensajes',
  Promotion: 'Promoción',
  Participants: 'Participantes',
  Client: 'Cliente',
  description_placeholder:
    'Describa a sus futuros participantes la atmósfera excepcional que prevalecerá en su evento.',
  Tickets_collection: 'Colección de entradas',
  Stop_sell_time_is_at: 'La hora de cierre de ventas es a las',
  drag_and_drop: 'Arrastra y suelta para cambiar el orden',
  delete_ticket_confirmation: '¿Estás seguro de que quieres eliminar este boleto?',
  Access_Time_Thresholdt: 'Hora de finalización del acceso al evento',
  order: 'orden',
  Créez_les_tickets_pour_votre_événement: 'Crea entradas para tu evento',
  stop_sell_time_error_message:
    'La fecha de finalización debe ser posterior a la fecha de inicio y no debe superar la fecha de cierre de ventas',
  Reset: 'Restablecer',
  send_invitation: 'Enviar invitación',
  Tickets_quantity_error_message:
    'La cantidad total de boletos ha alcanzado la capacidad máxima del evento, que es',
  Write_something_awesome: 'Escribe algo increíble...',
  Code: 'Código',
  delete_promocode_confirm_message: '¿Estás seguro de que quieres eliminar este código?',
  Activate_promotion: 'Activar promoción',
  Desactivate_promotion: 'Desactivar promoción',
  Configure_RP_offer: 'Configurar la oferta de Promobooster',
  promotion_status: 'estado de promoción',
  TooltipTextForPromotionGroups:
    'En esta sección, puede crear y gestionar grupos de Personas de Recursos (PR) para sus eventos.',
  TooltipTextForEventLink: 'Publique su evento para obtener el enlace de su evento.',
  TooltipTextForPromotionGroupsForReferral:
    'En esta sección, encontrarás los grupos de Promobooster de los que eres miembro y podrás salir del grupo cuando lo desees.',
  confirm_delete_promoter: '¿Estás seguro de que deseas eliminar a este PromoBooster?',
  Preview_promoter_link: 'Vista previa del enlace del PromoBooster',
  Locked: 'Bloqueado',
  pending: 'Pendiente',
  accepted: 'Aceptado',
  rejected: 'Rechazado',
  Publish_my_event_now: 'Publicar mi evento ahora',
  publish_later: 'Publicar más tarde',
  Your_event_is_still_draft:
    'Tu evento aún es un borrador, completa la configuración para publicarlo',
  Are_you_sure_to_publish_the_event: '¿Estás seguro de publicar el evento?  ',
  pourcentage: 'porcentaje',
  Rate: 'Tasa',
  Message: 'Mensaje',
  submit: 'entregar',
  Create_group: 'crea un grupo',
  Groups: 'Grupos',
  Edit_group: 'Editar grupo',
  Search_by_Name: 'Buscar por nombre',
  Enter_group_name: 'Introduzca el nombre del grupo',
  No_promoters_found: 'No se encontraron PromoBoosteres',
  Add_group: 'Añadir grupo',
  Number_of_sales: 'Número de ventas',
  Turnover: 'Cifra de negocio',
  Number_of_clients: 'Numero de clientes',
  Promotion_requests: 'Solicitudes de promoción',
  Requests: 'Peticiones',
  Notifications: 'Notificaciones',
  Referral_requests: 'Solicitudes de PromoBooster',
  no_requests: 'No hay solicitudes',
  request_message: 'te envió una solicitud para invitarte a ser el PromoBooster de',
  Accept: 'Aceptar',
  Reject: 'Rechazar',
  Your_invitation_to: 'Tu invitación a',
  on: 'el',
  at: 'a las',
  is: 'està',
  promotion_rate: 'tasa de promoción',
  consigne: 'consigna',
  Cancel_request: 'cancelar petición',
  Send_request: 'Enviar petición',
  No_events: 'Encuentre un evento con el que le gustaría colaborar como PromoBooster',
  Search_for_new_events: 'Buscar nuevos eventos',
  Search_for_Events: 'Buscar eventos',
  Sales_stats: 'Estadísticas de ventas',
  Total_sales: 'Ventas totales',
  Total_reservation: 'Total reservations',
  Bienvenue_message: 'Bienvenido a I.D, elija su sector',
  second_bienvenu_message: 'Bienvenido a I.D, seleccione su sector entre eventos y catering.',
  Continue: 'continuar',
  Event: 'Evento',
  orga_message: 'Elija la organización bajo la cual creará su evento',
  Skip: 'Pasar',
  All_steps_completed: 'Todos los pasos completados',
  you_have_finished: 'ha terminado',
  limit_sell_message: 'Ingrese una fecha límite y hora para la venta de boletos',
  stopSellDate: 'Dejar de vender entradas con fecha',
  status_tooltip:
    'Este campo de estado calcula automáticamente la fecha de inicio y la fecha de fin, y te proporciona el estado del evento',
  Step: 'Paso',
  correct_start_date: 'Corregir la fecha de inicio pasada',
  Finish: 'Finalizar',
  event_name_tooltip: '¿Cómo se llama tu evento?',
  event_summary_tooltip:
    'Dé un vistazo a las hermosas sorpresas que esperan a los futuros participantes en su evento.',
  event_description_tooltip:
    'En esta ocasión, describa en detalle el evento al que los futuros participantes tendrán la oportunidad de asistir.',
  event_cover_tooltip: 'Elija una foto para su evento.',
  organisation_tooltip: 'Elija el nombre de la organización que organizará su evento.',
  category_tooltip: 'Seleccione una categoría para su evento.',
  subCategory_tooltip: 'Elija una subcategoría para su evento.',
  Business: 'Negocios',
  Charity: 'Caridad',
  Causes: 'Causas',
  Community: 'Comunidad',
  Concerts: 'Conciertos',
  Music: 'Música',
  Conferences: 'Conferencias',
  Expos: 'Exposiciones',
  Fashion: 'Moda',
  Festivals: 'Festivales',
  Film: 'Cine',
  Media: 'Medios',
  Food: 'Comida',
  Drink: 'Bebida',
  Health: 'Salud',
  Hobbies: 'Aficiones',
  Nightlife: 'Vida nocturna',
  Other: 'Otros',
  Performing: 'Artes escénicas',
  arts: 'arte',
  Seasonal: 'Estacional',
  Holiday: 'Vacaciones',
  Sports: 'Deportes',
  Fitness: 'Fitness',
  Travel: 'Viaje',
  Outdoor: 'Aire libre',
  Career: 'Carrera',
  Design: 'Diseño',
  Educators: 'Educadores',
  Environment: 'Medio ambiente',
  Sustainability: 'Sostenibilidad',
  Finance: 'Finanzas',
  Investment: 'Inversión',
  Non: 'No',
  Profit: 'Lucrativo',
  NGOs: 'ONG',
  Real: 'Real',
  Estate: 'Inmobiliario',
  Sales: 'Ventas',
  Marketing: 'Marketing',
  Startups: 'Startups',
  Small: 'Pequeñas',
  Animal: 'Animal',
  Welfare: 'Bienestar',
  Art: 'Arte',
  Auctions: 'Subastas',
  Benefit: 'Beneficio',
  Walks: 'Caminatas',
  Disaster: 'Desastre',
  Relief: 'Alivio',
  Donor: 'Donante',
  Recognition: 'Reconocimiento',
  Educational: 'Educativas',
  Fundraising: 'Recaudación de fondos',
  Homeless: 'Personas sin hogar',
  shelters: 'Refugios',
  Human: 'Humano',
  Rights: 'Derechos',
  International: 'Internacional',
  Aid: 'Ayuda',
  Marches: 'Marchas',
  Poverty: 'Pobreza',
  Rallies: 'Manifestaciones',
  Demonstrations: 'Manifestaciones',
  Ethnic: 'Étnico',
  Fairs: 'Ferias',
  Farmers: 'Agricultores',
  markets: 'Mercados',
  Fetes: 'Fiestas',
  Fun: 'Diversión',
  runs: 'Carreras',
  Heritage: 'Herencia',
  Historic: 'Histórico',
  Language: 'Idioma',
  LGBTQ: 'LGBTQ',
  Nationality: 'Nacionalidad',
  Parades: 'Desfiles',
  Protests: 'Protestas',
  Religious: 'Religiosos',
  Renaissance: 'Renacimiento',
  Spiritual: 'Espiritual',
  Town: 'Pueblo',
  hall: 'salón',
  meetings: 'reuniones',
  Acoustic: 'Acústico',
  Americana: 'Americana',
  Bluegrass: 'Bluegrass',
  Blues: 'Blues',
  Jazz: 'Jazz',
  Classical: 'Clásica',
  Cultural: 'Cultural',
  Dance: 'Danza',
  EDM: 'Música electrónica',
  Electronic: 'Electrónica',
  Experimental: 'Experimental',
  Folk: 'Folk',
  Hip: 'Hip',
  Hop: 'Hop',
  Rap: 'Rap',
  Indie: 'Indie',
  Latin: 'Latina',
  Metal: 'Metal',
  Opera: 'Ópera',
  Pop: 'Pop',
  Psychedelic: 'Psicodélico',
  Reggae: 'Reggae',
  Rock: 'Rock',
  Singer: 'Cantante',
  Songwriter: 'Cantautor',
  Top: 'Top',
  World: 'Mundo',
  Colloquium: 'Coloquio',
  Conference: 'Conferencia',
  Congress: 'Congreso',
  Convention: 'Convención',
  Demonstration: 'Demostración',
  Exhibition: 'Exhibición',
  Forum: 'Foro',
  Meeting: 'Reunión',
  Presentation: 'Presentación',
  Round: 'Redonda',
  table: 'mesa',
  Seminar: 'Seminario',
  Symposium: 'Simposio',
  Workshop: 'Taller',
  Award: 'Premio',
  Ceremonies: 'Ceremonias',
  Screening: 'Proyección',
  Movie: 'Película',
  Premiere: 'Estreno',
  Television: 'Televisión',
  Video: 'Video',
  Game: 'Juego',
  Education: 'Educación',
  Industry: 'Industria',
  Science: 'Ciencia',
  Technology: 'Tecnología',
  Barbecue: 'Barbacoa',
  Breakfast: 'Desayuno',
  Brunch: 'Brunch',
  Buffet: 'Buffet',
  Cocktail: 'Cóctel',
  Mixology: 'Mixología',
  Culinary: 'Culinaria',
  workshops: 'talleres',
  Dessert: 'Postre',
  Pastry: 'Pastelería',
  Tastings: 'Degustaciones',
  Dinner: 'Cena',
  Farm: 'Granja',
  to: 'a',
  Table: 'mesa',
  Dining: 'Cena',
  Gourmet: 'Gourmet',
  Markets: 'Mercados',
  Lunch: 'Almuerzo',
  Picnic: 'Picnic',
  Wine: 'Vino',
  Beer: 'Cerveza',
  Adult: 'Adulto',
  Anime: 'Anime',
  Comics: 'Cómics',
  Book: 'Libro',
  Books: 'Libros',
  Collecting: 'Coleccionismo',
  Cooking: 'Cocina',
  DIY: 'Hazlo tú mismo',
  Crafts: 'Manualidades',
  Drawing: 'Dibujo',
  Painting: 'Pintura',
  Gaming: 'Juegos',
  Gardening: 'Jardinería',
  Home: 'Hogar',
  Improvement: 'Mejoras',
  Knitting: 'Tejido',
  Photography: 'Fotografía',
  Reading: 'Lectura',
  Sewing: 'Costura',
  Writing: 'Escritura',
  Bar: 'Bar',
  Crawls: 'Rastreo',
  Bingo: 'Bingo',
  Cabaret: 'Cabaret',
  Casino: 'Casino',
  Comedy: 'Comedia',
  Clubs: 'Clubes',
  Parties: 'Fiestas',
  Dancehall: 'Dancehall',
  Drinks: 'Bebidas',
  Karaoke: 'Karaoke',
  Nightclubs: 'Clubs nocturnos',
  Open: 'Abierto',
  Mic: 'Micrófono',
  Pubs: 'Pubs',
  Raves: 'Raves',
  Medical: 'Médico',
  Spa: 'Spa',
  Yoga: 'Yoga',
  Circus: 'Circo',
  Exhibitions: 'Exhibiciones',
  Magic: 'Magia',
  Musicals: 'Musicales',
  Plays: 'Obras de teatro',
  Theater: 'Teatro',
  Christmas: 'Navidad',
  Easter: 'Pascua',
  Halloween: 'Halloween',
  Hanukkah: 'Hanukkah',
  New: 'Nuevo',
  Year: 'Año',
  Eve: 'Víspera',
  Thanksgiving: 'Día de Acción de Gracias',
  Archery: 'Tiro con arco',
  Baseball: 'Béisbol',
  Basketball: 'Baloncesto',
  Camping: 'Campamento',
  Camps: 'Campamentos',
  Cars: 'Coches',
  Cheer: 'Porra',
  Climbing: 'Escalada',
  Cycling: 'Ciclismo',
  Diving: 'Buceo',
  Exercise: 'Ejercicio',
  Fishing: 'Pesca',
  Football: 'Fútbol',
  Golf: 'Golf',
  Hiking: 'Senderismo',
  Hockey: 'Hockey',
  Hunting: 'Caza',
  Jogging: 'Trote',
  Lacrosse: 'Lacrosse',
  Motorsports: 'Deportes de motor',
  Obstacles: 'Obstáculos',
  Parachuting: 'Paracaidismo',
  Rally: 'Rally',
  Rugby: 'Rugby',
  Running: 'Correr',
  Skating: 'Patinaje',
  Skiing: 'Esquí',
  Snow: 'Nieve',
  Snowboarding: 'Snowboard',
  Soccer: 'Fútbol',
  Softball: 'Softbol',
  Sport: 'Deporte',
  Surfing: 'Surf',
  Swimming: 'Natación',
  Water: 'Agua',
  Tennis: 'Tenis',
  Volleyball: 'Voleibol',
  Walking: 'Caminata',
  Weightlifting: 'Levantamiento de pesas',
  Windsurfing: 'Windsurf',
  Wrestling: 'Lucha',
  Cruise: 'Crucero',
  Expeditions: 'Expediciones',
  Museum: 'Museo',
  visit: 'visita',
  Road: 'Viajes',
  Trips: 'Viajes',
  tours: 'Tours',
  Rp_request: 'Te envié solicitud para ser el PromoBooster de su evento.',
  warning_message: 'Por favor presione "agregar" primero para guardar su boleto y continuar',
  correct_date_tooltip: 'La fecha de inicio seleccionada para su evento ya ha pasado.',
  step1:
    'En este paso, encontrará las estadísticas de ventas del evento y la lista de asistentes al evento.',
  step2: 'En este paso, puede editar los detalles del evento.',
  step3: 'En este paso, puede editar las fechas y horas del evento.',
  step4:
    'En este paso, puede agregar nuevos boletos para su evento o editar los boletos existentes.',
  step5: 'En este paso, puede publicar o archivar su evento.',
  step6:
    'En este paso, encontrará la vista del evento para clientes en la vista de escritorio o móvil.',
  step7: 'En este paso, encontrará una descripción general de los detalles de su evento.',
  step8: 'En este paso, puedes obtener información sobre el evento.',
  stepCodePromo: 'En este paso, puede agregar códigos promocionales para los boletos.',
  step10:
    'En este paso, puede gestionar los PromoBooster de su evento, crear un grupo de PromoBooster o enviar solicitudes para que el PromoBooster sea PromoBooster de su evento.',
  step11: 'En este paso, encontrará la lista de los asistentes.',
  total_sold_tooltip: 'Este es el ingreso total del evento (entradas + goodies).',
  sold_quantity_tooltip: 'Esta es la cantidad total de entradas vendidas para el evento.',
  link_tooltip: 'Este es el enlace del evento para comprar tus entradas.',
  table_tooltip: 'Aquí está la tabla donde encontrarás la lista de los asistentes a este evento.',
  create_event_button_tooltip: 'Haz clic aquí para crear un nuevo evento.',
  events_table_tooltip:
    'Esta es la tabla de eventos donde puedes encontrar los detalles de tus eventos.',
  You_have_no_organisations: 'No tienes organizaciones',
  alert_orga_title: 'Debes crear una organización para poder crear un evento después.',
  Configurate_here: 'Configura aquí',
  legal_verification: 'Verificación legal de tu cuenta',
  alert_stripe_configuration_title:
    'Por favor, completa tu información legal para activar tu cuenta y poder vender tus entradas.',
  Bank_balance: 'Saldo bancario',
  View_my_Stripe_account: 'Ver mi cuenta de Stripe',
  Your_balance: 'Tu saldo',
  Add_new_card: 'Agregar nueva tarjeta',
  Name_on_card: 'Nombre en la tarjeta',
  Card_number: 'Número de tarjeta',
  Expiration_date: 'Fecha de vencimiento',
  QRcode_tooltip: 'Haz clic aquí para personalizar y descargar el código QR de tu evento',
  File_Type: 'Tipo de archivo',
  Size: 'Tamaño',
  Color: 'Color',
  Background_Color: 'Color de fondo',
  Download_QR_Code: 'Descargar código QR',
  Download_Invoice: 'Descargar factura',
  show_qr_code: 'Mostrar código QR',
  Close: 'Cerrar',
  Customize_QR_Code: 'Personalizar código QR',
  no_users_yet: 'Aún no hay usuarios',
  plz_invite_users: 'Por favor, invite a usuarios',
  invite_organizer: 'Invitar al organizador',
  invite: 'invitar',
  invite_owners: 'invitar propietarios',
  register: 'Registrarse',
  password: 'Contraseña',
  confirm_password: 'Confirmar Contraseña',
  email_adress: 'Dirección de Correo Electrónico',
  division_agent: 'Agente',
  division_promoter: 'Promoter',
  iam_owner: 'Soy Propietario',
  iam_owner_desc: 'Administra tus organizaciones, restaurantes y eventos',
  iam_amb: 'Soy Embajador',
  iam_amb_desc: 'Promociona organizaciones y gana comisiones',
  iam_ref: 'Soy PromoBooster',
  iam_ref_desc: 'Refiere eventos y gana comisiones',
  start_free: 'Comenzar Gratis',
  no_credit_card: 'No se requiere tarjeta de crédito',
  have_account: '¿Ya tienes una cuenta?',
  by_register_1: 'Al registrarme, acepto los ',
  by_register_2: 'Términos de Servicio',
  by_register_3: ' y la ',
  by_register_4: 'Política de Privacidad de I.D.',
  manager_better_register: 'Administra eventos de manera más eficiente con I.D',
  referral: 'PromoBooster',
  first_name_required: 'Se requiere nombre',
  first_name_short: 'El nombre es demasiado corto - debe tener al menos 3 caracteres.',
  first_name_long: 'El nombre es demasiado largo - debe tener como máximo 50 caracteres.',
  first_name_alpha: 'El nombre solo puede contener caracteres alfabéticos.',
  last_name_required: 'Se requiere apellido',
  last_name_short: 'El apellido es demasiado corto - debe tener al menos 3 caracteres.',
  last_name_long: 'El apellido es demasiado largo - debe tener como máximo 50 caracteres.',
  last_name_alpha: 'El apellido solo puede contener caracteres alfabéticos.',
  email_invalid: 'El correo electrónico debe ser una dirección de correo válida',
  email_required: 'Se requiere correo electrónico',
  password_required: 'Se requiere contraseña',
  password_short: 'La contraseña es demasiado corta - debe tener al menos 8 caracteres.',
  password_long: 'La contraseña es demasiado larga - debe tener como máximo 128 caracteres.',
  password_alpha: 'La contraseña solo puede contener letras latinas.',
  password_lowercase: 'La contraseña debe contener al menos una letra minúscula.',
  password_uppercase: 'La contraseña debe contener al menos una letra mayúscula.',
  password_number: 'La contraseña debe contener un número.',
  password_special: 'La contraseña debe contener al menos un carácter especial.',
  password_no_repeat: 'La contraseña no debe contener el mismo carácter tres veces seguidas.',
  confirm_password_match: 'Las contraseñas deben coincidir',
  confirm_password_required: 'Se requiere confirmar contraseña',
  division_required: 'Se requiere división',
  division_invalid: 'La división debe ser PromoBooster o Agente',
  role_required: 'Se requiere rol',
  role_invalid_promoter: 'Rol inválido para PromoBooster',
  role_invalid_agent: 'Rol inválido para Agente',
  login: 'Iniciar Sesión',
  fr: 'Français',
  en: 'English',
  es: 'Espagnol',
  pt: 'Portugais',
  lang: 'Idioma',
  creating_account: 'Creación de Cuenta en Progreso',
  creating_account_desc: 'Finalizando la Configuración de su Cuenta',
  creating_account_info:
    'Su cuenta está siendo configurada. Por favor, permanezca en esta página hasta que el proceso esté completo. ¡Agradecemos su paciencia!',
  accept_invitation_info:
    'Tenga en cuenta que, después de aceptar la invitación a continuación, recibirá un correo electrónico de verificación. Después de la verificación, podrá completar la configuración de su cuenta, incluidas las opciones para cambiar su nombre y el idioma preferido.',
  invitation_already_processed:
    'Esta invitación ya ha sido procesada. Por favor, consulte su panel de eventos para más información.',
  'invitation.continuation_title': 'Invitación ya enviada!',
  'invitation.continuation_body':
    'Ya se envió una invitación para este correo. Revisa tu bandeja de entrada (y correo no deseado) y haz clic en el enlace de verificación.\n\nSi no encuentra el correo, puedes continuar tocando el botón <0>Reinvitar</0>.',
  'invitation.continuation_use_existing': 'Revisaré mi correo',
  'invitation.continuation_start_new': 'Reinvitar',
  verify_email: 'Verifique Su Correo Electrónico',
  verify_email_desc: 'Cuenta Creada con Éxito',
  verify_email_info:
    '¡Felicidades por configurar su cuenta! Por favor, revise su bandeja de entrada para verificar su cuenta y obtener acceso completo.',
  wait_verify: 'Por favor, espere un momento mientras verificamos su correo electrónico.',
  wait_redirect: 'No cierre esta ventana hasta que haya sido redirigido al panel de control.',
  initialAccountHeader: 'Finaliza tu cuenta de I.D',
  initialAccountDescription:
    '¡Bienvenido de nuevo! Solo establece tu contraseña a continuación para finalizar la configuración de tu cuenta.',
  initialAccountButton: 'Completar configuración',
  processingAccountHeader: 'Configurando tu cuenta...',
  processingAccountDescription:
    'Por favor, espera un momento mientras confirmamos tus detalles y aseguramos tu cuenta.',
  processingAccountButton: 'Completando...',
  successAccountHeader: '¡Éxito! Cuenta lista',
  successAccountDescription:
    'Tu cuenta se ha configurado con éxito y estás iniciando sesión. Serás redirigido al tablero de mandos en breve.',
  successAccountButton: 'Redirigiendo...',
  errorAccountHeader: 'Algo salió mal',
  errorAccountDescription:
    'Hubo un problema con la configuración de tu cuenta. El enlace puede ser inválido o haber expirado, o el correo electrónico puede ser incorrecto.',
  errorAccountButton: 'Intentar de nuevo',
  linkexpiredAccountHeader: 'Revisa Tu Correo Electrónico',
  linkexpiredAccountDescription:
    'Hubo un problema con la configuración de tu cuenta. El enlace podría ser inválido o haber expirado, o la dirección de correo electrónico podría ser incorrecta.',
  verification_expired:
    '¡Fallo en la configuración de la cuenta! El enlace de verificación de tu cuenta ha expirado.',
  new_verification_link_sent:
    'Se ha enviado un nuevo enlace de verificación a tu dirección de correo electrónico.',
  login_welcome: 'Hola, Bienvenido',
  login_connect: 'Inicia sesión en I.D',
  login_type: 'Ingresa tus datos abajo.',
  login_no_account: '¿No tienes una cuenta?',
  login_register: 'Registrarse',
  owner_total_part:
    'Estas son las acciones del propietario para la venta de entradas para el evento.',
  my_share: 'Mi parte',
  Remember_password: 'Recordar contraseña',
  forgot_password: '¿Contraseña olvidada?',
  create_your_first_organization: 'Crea tu primera organización',
  create_organization_step_description:
    'Para empezar a gestionar tus eventos, crea tu primera organización. Puedes crear tantas organizaciones como quieras más adelante.',
  create_your_first_event: 'Crea tu primer evento',
  create_event_step_description:
    'Ahora que has creado tu primera organización, es hora de crear brevemente tu primer evento. Puedes editarlo en detalle más tarde.',
  congratulations: '¡Felicidades!',
  last_step_description: 'Ahora puedes ir a la lista de eventos y continuar creando tu evento.',
  create_your_first_restaurant: 'Crea tu primer restaurante',
  create_restaurant_step_description:
    'Para empezar a gestionar tus mesas, crea tu primer restaurante. Puedes crear tantos restaurantes como quieras más adelante.',
  create_restaurant_last_step_description:
    'Ahora puedes ir a la lista de restaurantes y continuar creando tus mesas.',
  Logout: 'Cerrar sesión',
  Settings: 'Configuración',
  create_store: 'Crear restaurante',
  add_category: 'Agregar categoría',
  select_store: 'Seleccionar un restaurante',
  add_new_product: 'Agregar nuevo producto',
  add_new_category: 'Agregar nueva categoría',
  products: 'Productos',
  categories: 'Categorías',
  unavailable: 'No disponible',
  composite: 'Compuesto',
  alcoholic: 'Alcohólico',
  Available: 'Disponible',
  Description: 'Descripción',
  simple: 'Simple',
  search_product: 'Buscar producto...',
  min_price: 'Precio mínimo',
  max_price: 'Precio máximo',
  add_product: 'Agregar producto',
  edit_product: 'Editar producto',
  product_details: 'Detalles del producto',
  composition_items: 'Ítems de composición',
  caption: 'Subtítulo',
  extra: 'Extra',
  max_quantity: 'Cantidad máxima',
  add_composition: 'Agregar composición',
  items: 'Artículos',
  item_name: 'Nombre del artículo',
  add_item: 'Agregar artículo',
  preparation_time: 'Tiempo de preparación',
  Orders: 'Pedidos',
  current_orders: 'Órdenes Actuales',
  store: 'Restaurante',
  no_stores_message: 'No tienes restaurantes para ver órdenes, por favor crea una primero',
  Pending: 'Pendiente',
  in_preparation: 'En Preparación',
  Preparation: 'Preparación',
  accept_order: 'Aceptar pedido',
  order_is_ready: 'El pedido está listo',
  finish_order: 'Finalizar pedido',
  total: 'Total',
  order_of: 'Pedido de',
  Contact: 'Contacto',
  reservations_shares: 'Compartir reservas',
  client_name: 'Nombre del cliente',
  total_amount: 'Cantidad total',
  owner_share: 'Participación del propietario',
  instadrink_share: 'Participación de I.D',
  rp_share: 'Participación de PromoBooster',
  thanks_join_invite: 'Gracias por unirte a nuestra comunidad',
  ambassador_share: 'Participación del embajador',
  shares_distribution: 'Distribución de acciones',
  group_name: 'Nombre del grupo',
  group_members: 'Miembros del grupo',
  created_by: 'Creado por',
  leave_group: 'Abandonar el grupo',
  with_product: 'Con producto',
  all_categories: 'Todas las categorías',
  inclusives: 'Incluyentes',
  closing_Time: 'Hora de cierre',
  open: 'Abierto',
  Rush_hour: 'Hora pico',
  preview_store: 'Vista previa del restaurante',
  Delete_account: 'Eliminar cuenta',
  Are_you_sure_you_want_to_delete_your_account: '¿Estás seguro de que deseas eliminar tu cuenta',
  delete_account_page_message:
    'Al elegir eliminar tu cuenta, estás optando por la eliminación permanente de todos tus datos de nuestro sistema.',
  restaurants: 'Restaurantes',
  stores: 'Tiendas',
  network: 'Red',
  commandes: 'Pedidos',
  applications: 'Aplicaciones',
  inviteUsers: 'Invitar usuarios',
  inviteAgents: 'Invitar agentes',
  inviteStaff: 'Invitar personal',
  invitationsList: 'Lista de invitaciones',
  promotersTree: 'Árbol de invitaciones',
  promotionGroups: 'Grupos de PromoBoosters',
  onboarding: 'Onboarding',

  enhanced_organization: {
    address_requires_coordinates: 'Por favor, seleccione una dirección válida de las sugerencias',

    // Step Labels
    step_labels: {
      basic: 'Información básica',
      contact: 'Información de contacto',
      type: 'Tipo de organización',
      roles: 'Roles del personal',
      staff: 'Miembros del equipo',
      features: 'Funciones y ajustes',
      availability: 'Disponibilidad y horarios',
      showcase: 'Exposición musical',
      quick_setup: 'Configuración rápida',
    },

    // Dialog Title and General
    create_organization: 'Crear organización',
    step: 'Paso',
    of: 'de',
    quick_mode: 'Modo rápido',
    quick_setup: 'Configuración rápida',
    music_studio: 'Estudio de música',

    // Basic Information Step
    tell_us_about_organization: 'Cuéntanos sobre tu organización',
    basic_info_subtitle: 'Comencemos con la información básica',
    organization_name: 'Nombre de la organización',
    organization_name_required: 'Nombre de la organización *',
    organization_name_exists: 'El nombre de la organización ya existe',
    description: 'Descripción',
    description_required: 'Descripción *',
    language: 'Idioma',
    organization_logo: 'Logotipo de la organización',
    upload_logo: 'Subir logotipo',
    cover_image: 'Imagen de portada',
    upload_cover_image: 'Subir imagen de portada',
    change_logo: 'Cambiar logotipo',

    // Quick Mode
    quick_setup_mode: 'Modo de configuración rápida',
    using_quick_setup:
      'Usando configuración rápida con valores predeterminados - desactívala para configuración detallada',
    skip_detailed_setup:
      'Omitir la configuración detallada y usar valores predeterminados. Puedes configurarlo todo más tarde.',
    detailed_setup: 'Configuración detallada',

    // Contact Information Step
    contact_information: 'Información de contacto',
    contact_info_subtitle: 'Proporciona los datos de contacto y dirección de tu estudio',
    email_address: 'Dirección de correo electrónico',
    main_contact_email: 'Correo de contacto principal del estudio',
    phone_number: 'Número de teléfono',
    contact_phone_number: 'Número de teléfono de contacto',
    website: 'Sitio web',
    studio_website_optional: 'Sitio web del estudio (opcional)',
    studio_address: 'Dirección del estudio',
    full_address_location: 'Dirección completa donde se encuentra tu estudio',
    location_verified: 'Ubicación verificada',
    no_locations_found: 'No se encontraron ubicaciones',
    contact_info_help:
      'La información de contacto ayuda a los clientes a encontrar y contactar tu estudio. Puedes actualizar estos datos más tarde en la configuración.',

    // Type Selection Step
    creating_music_studio: 'Creando un estudio de música',
    creating_studio_subtitle:
      'Estás creando una organización de estudio de grabación con funciones avanzadas',
    what_type_organization: '¿Qué tipo de organización es esta?',
    type_selection_subtitle: 'Esto nos ayuda a personalizar la experiencia para ti',
    existing: 'Existente',

    // Roles Setup Step
    set_up_staff_roles: 'Configura los roles del personal',
    roles_setup_subtitle: 'Define los roles de los miembros de tu equipo. Puedes omitir este paso.',
    use_recommended_roles: 'Usar roles recomendados para este tipo de organización',
    recommended_roles: 'Roles recomendados',
    custom_roles: 'Roles personalizados',
    role_name: 'Nombre del rol',

    // Staff Setup Step
    add_team_members: 'Agregar miembros del equipo',
    staff_setup_subtitle: 'Agrega los miembros de tu equipo. Siempre puedes añadir más después.',
    add_staff_member: 'Agregar miembro del personal',
    add_new_staff_member: 'Agregar nuevo miembro del personal',
    name: 'Nombre',
    name_required: 'Nombre *',
    email: 'Correo electrónico',
    email_required: 'Correo electrónico *',
    password: 'Contraseña',
    leave_empty_default: 'Dejar vacío para usar el valor predeterminado (123)',
    role: 'Rol',
    cancel: 'Cancelar',
    add_member: 'Agregar miembro',
    added_staff_members: 'Miembros del personal agregados',
    custom_role: 'Rol personalizado',

    // Availability Setup Step
    studio_availability: 'Disponibilidad del estudio',
    availability_subtitle:
      'Configura los horarios de trabajo del estudio, franjas de reserva y reglas de disponibilidad',
    please_fix_issues: 'Por favor, corrige los siguientes problemas:',
    working_hours: 'Horas laborales',
    booking_rules: 'Reglas de reserva',
    time_slots: 'Franjas horarias',
    weekly_schedule: 'Horario semanal',
    weekly_schedule_subtitle:
      'Define las horas de funcionamiento del estudio para cada día de la semana. Habilita el modo 24 horas o establece horarios cruzados (por ejemplo, 22:00 a 06:00 del día siguiente)',

    // Cross-Day Booking Policy
    cross_day_booking_policy: 'Política de reservas cruzadas por día',
    enable_cross_day_bookings: 'Habilitar reservas que crucen el día',
    cross_day_help:
      'Permitir reservas que se extiendan más allá de la medianoche (por ejemplo, 23:00 a 2:00)',
    max_cross_day_hours: 'Máx. horas cruzadas por día',
    max_cross_day_help: 'Máximo de horas que una reserva puede abarcar entre días',
    allow_weekend_crossover: 'Permitir cruce de fin de semana',
    weekend_crossover_help:
      'Permitir reservas que crucen del fin de semana a un día laboral o viceversa',
    require_same_day_start: 'Requerir inicio el mismo día',
    same_day_start_help: 'La reserva debe comenzar y terminar en el mismo día calendario',

    // Days of Week
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',

    // Time Configuration
    start_time: 'Hora de inicio',
    end_time: 'Hora de finalización',
    next_day: 'Día siguiente',
    cross_midnight_schedule: 'Horario que cruza medianoche:',

    // Booking Configuration
    booking_configuration: 'Configuración de reservas',
    booking_config_subtitle: 'Configura las reglas y restricciones de reserva',
    advance_booking_days: 'Días de reserva anticipada',
    advance_booking_help: 'Cuántos días antes pueden reservar los clientes',
    minimum_notice_hours: 'Aviso mínimo (horas)',
    minimum_notice_help: 'Horas mínimas antes de una reserva',
    max_session_duration: 'Duración máxima de sesión (minutos)',
    max_duration_help: 'Duración máxima de reserva',
    buffer_time_minutes: 'Tiempo de pausa (minutos)',
    buffer_time_help: 'Tiempo de descanso entre reservas',
    auto_approve_bookings: 'Aprobar reservas automáticamente',
    auto_approve_help: 'Aprobar solicitudes de reserva automáticamente sin revisión manual',
    allow_back_to_back: 'Permitir reservas consecutivas',
    back_to_back_help: 'Permitir programar reservas de forma consecutiva',

    // Time Slot Configuration
    time_slot_configuration: 'Configuración de franjas horarias',
    time_slot_subtitle: 'Configura las franjas e intervalos de reserva',
    time_slot_unit: 'Unidad de franja horaria',
    default_slot_duration: 'Duración predeterminada (minutos)',
    slot_duration_help: 'Duración predeterminada de las franjas de reserva',
    time_slot_help:
      'Las franjas se generarán según tus horas de trabajo y unidad de tiempo seleccionada. Los clientes podrán elegir entre las disponibles al reservar.',

    // Actions
    reset_to_defaults: 'Restablecer valores predeterminados',
    current_settings_applied:
      'La configuración actual se aplicará al completar el proceso de incorporación',
    availability_for_studios:
      'Los ajustes de disponibilidad están diseñados principalmente para estudios de grabación. Puedes configurarlos más tarde en tu panel.',
    skip_configure_later:
      'Puedes omitir este paso y configurar la disponibilidad más tarde en tu panel. Estos ajustes ayudan a automatizar tu proceso de reservas y mejorar la experiencia del cliente.',

    // Showcase Setup Step
    music_showcase: 'Exposición musical',
    showcase_subtitle:
      'Configura una exposición musical para mostrar el trabajo de tu estudio a los clientes',
    enable_music_showcase: 'Habilitar exposición musical',
    showcase_enabled_help:
      'Al habilitarlo, tu exposición musical será visible para los clientes en el perfil de tu estudio',
    showcase_title: 'Título de la exposición',
    showcase_title_placeholder: 'Ej: Nuestras últimas producciones',
    showcase_description: 'Descripción de la exposición',
    showcase_description_placeholder: 'Describe tu exposición musical...',
    add_music_tracks_later:
      'Puedes agregar pistas de YouTube, Spotify, SoundCloud y otras plataformas después de completar la configuración.',
    showcase_for_studios:
      'La exposición musical está diseñada específicamente para estudios de grabación. Este paso puede omitirse para otros tipos de organización.',
    configure_showcase_later:
      'No te preocupes, siempre podrás configurar tu exposición musical más tarde en tu panel.',

    // Quick Setup Step
    quick_setup_title: 'Configuración rápida',
    quick_setup_subtitle_studio:
      'Crea tu estudio musical con una configuración mínima. Podrás personalizarlo todo más tarde.',
    quick_setup_subtitle_general:
      'Crea tu organización con una configuración mínima. Podrás personalizarla más adelante.',
    contact_email: 'Correo de contacto',
    contact_phone: 'Teléfono de contacto',
    logo: 'Logotipo',
    optional: 'Opcional',
    studio_description_placeholder:
      'Describe tu estudio musical, especialidades y lo que lo hace único...',
    organization_description_placeholder: 'Describe tu organización y los servicios que ofrece...',

    // Default Settings Preview
    default_settings_applied: 'Configuración predeterminada aplicada',
    standard_working_hours: 'Horario laboral estándar',
    basic_booking_settings: 'Configuración básica de reservas',
    default_roles: 'Roles predeterminados',
    core_features_enabled: 'Funciones principales habilitadas',
    standard_availability_settings: 'Configuración estándar de disponibilidad',
    basic_notification_preferences: 'Preferencias básicas de notificación',
    customize_settings_later:
      'Todas las configuraciones se pueden personalizar más tarde en tu panel.',
    changed_your_mind: '¿Cambiaste de opinión?',
    switch_to_detailed:
      'Puedes cambiar a la configuración detallada para ajustar roles, personal, funciones y disponibilidad paso a paso. Tu información básica se conservará.',

    // Navigation
    back: 'Atrás',
    skip: 'Omitir',
    next: 'Siguiente',
    complete_setup: 'Finalizar configuración',

    // Validation Messages
    validation: {
      advance_booking_range: 'Los días de reserva anticipada deben estar entre 1 y 365',
      minimum_notice_positive: 'El aviso mínimo de reserva no puede ser negativo',
      max_duration_minimum: 'La duración máxima debe ser de al menos 15 minutos',
      slot_duration_minimum: 'La duración de la franja debe ser de al menos 15 minutos',
      buffer_time_positive: 'El tiempo de pausa no puede ser negativo',
      reset_success: 'Configuración de disponibilidad restablecida a los valores predeterminados',
      fix_issues: 'Por favor, corrige los siguientes problemas:',
      advance_booking_days: 'Los días de reserva anticipada deben ser un número positivo',
      minimum_notice_hours: 'Las horas de aviso mínimo deben ser un número positivo',
      max_session_duration: 'La duración máxima de la sesión debe ser un número positivo',
      buffer_time_minutes: 'El tiempo de pausa debe ser un número positivo',
      default_slot_duration: 'La duración predeterminada debe ser un número positivo',
    },

    // Completion Messages
    organization_created_success: '¡Organización creada con éxito!',
    create_organization_failed: 'Error al crear la organización',
    user_not_authenticated: 'Usuario no autenticado',

    // Additional Translation Keys for Enhanced UI
    days: {
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo',
    },
    time_units: {
      fifteenMinutes: '15 minutos',
      thirtyMinutes: '30 minutos',
      oneHour: '1 hora',
    },
    placeholders: {
      contact_email: 'contacto@studio.com',
      contact_phone: '+33 1 23 45 67 89',
    },
    alerts: {
      availability_reset:
        'Configuración de disponibilidad restablecida a los valores predeterminados',
      studio_availability_note:
        'Los ajustes de disponibilidad están diseñados principalmente para estudios de grabación. Puedes configurarlos más tarde en tu panel si es necesario.',
      skip_availability_note:
        'Puedes omitir este paso y configurar la disponibilidad más tarde en tu panel. Estos ajustes ayudan a automatizar tu proceso de reservas y la experiencia del cliente.',
    },

    availability: {
      cross_day_description:
        'Permitir reservas que se extiendan más allá de la medianoche (por ejemplo, 23:00 a 2:00)',
      max_cross_day_hours_help: 'Máximo de horas que una reserva puede abarcar entre días',
      weekend_crossover_help:
        'Permitir reservas que crucen del fin de semana a un día laboral o viceversa',
      same_day_start_help: 'La reserva debe comenzar y terminar en el mismo día calendario',
      next_day: 'Día siguiente',
      cross_midnight_schedule: 'Horario que cruza medianoche:',
      next_day_suffix: 'día siguiente',
      advance_booking_help: 'Cuántos días antes pueden reservar los clientes',
      min_notice_help: 'Horas mínimas antes de una reserva',
      max_duration_help: 'Duración máxima de reserva',
      buffer_time_help: 'Tiempo de descanso entre reservas',
      auto_approve_help: 'Aprobar solicitudes de reserva automáticamente sin revisión manual',
      back_to_back_help: 'Permitir programar reservas de forma consecutiva',
      slot_duration_help: 'Duración predeterminada de las franjas de reserva',
      time_slots_explanation:
        'Las franjas se generarán según tus horas de trabajo y unidad de tiempo seleccionada. Los clientes podrán elegir entre las disponibles al reservar.',
      settings_apply_note:
        'La configuración actual se aplicará al completar el proceso de incorporación',
    },
    tabs: {
      working_hours: 'Horas laborales',
      booking_rules: 'Reglas de reserva',
      time_slots: 'Franjas horarias',
    },
    sections: {
      weekly_schedule: 'Horario semanal',
      weekly_schedule_description:
        'Define las horas de funcionamiento del estudio para cada día de la semana. Habilita el modo 24 horas o establece horarios cruzados (por ejemplo, 22:00 a 06:00 del día siguiente)',
      cross_day_policy: 'Política de reservas cruzadas por día',
      booking_configuration: 'Configuración de reservas',
      booking_configuration_description: 'Configura las reglas y restricciones de reserva',
      time_slot_configuration: 'Configuración de franjas horarias',
      time_slot_description: 'Configura las franjas e intervalos de reserva',
    },
    controls: {
      enable_cross_day: 'Habilitar reservas cruzadas por día',
      max_cross_day_hours: 'Máx. horas cruzadas por día',
      allow_weekend_crossover: 'Permitir cruce de fin de semana',
      require_same_day_start: 'Requerir inicio el mismo día',
      twentyFourHours: '24h',
      start_time: 'Hora de inicio',
      end_time: 'Hora de finalización',
      advance_booking_days: 'Días de reserva anticipada',
      minimum_notice_hours: 'Aviso mínimo (horas)',
      max_session_duration: 'Duración máxima de sesión (minutos)',
      buffer_time_minutes: 'Tiempo de pausa (minutos)',
      auto_approve_bookings: 'Aprobar reservas automáticamente',
      allow_back_to_back: 'Permitir reservas consecutivas',
      time_slot_unit: 'Unidad de franja horaria',
      default_slot_duration: 'Duración predeterminada (minutos)',
    },
    quick_setup_content: {
      studio_description:
        'Crea un perfil profesional de estudio musical con funciones y configuraciones esenciales',
      org_description: 'Crea tu organización con configuración básica y funciones esenciales',
      organization_name_required: 'Nombre de la organización *',
      description_required: 'Descripción *',
      studio_placeholder: 'Describe tu estudio de grabación, servicios y especialidades...',
      org_placeholder: 'Describe los servicios y la misión de tu organización...',
      optional: 'Opcional',
      change_logo: 'Cambiar logotipo',
      upload_logo: 'Subir logotipo',
      default_settings_applied: 'Configuración predeterminada aplicada',
      detailed_setup: 'Configuración detallada',
      standard_working_hours: 'Horario laboral estándar (9 AM - 6 PM, lunes a viernes)',
      basic_booking_settings: 'Configuración básica de reservas con franjas de 1 hora',
      auto_approval: 'Aprobación automática habilitada para agilizar las reservas',
      advance_booking: 'Ventana de reserva anticipada de 7 días',
      buffer_time: 'Pausa de 30 minutos entre sesiones',
      customize_later_note:
        'Todas las configuraciones pueden personalizarse más tarde en tu panel.',
      changed_mind: '¿Cambiaste de opinión?',
      switch_to_detailed:
        'Cambia a configuración detallada para tener control total sobre la organización.',
    },
    showcase: {
      title: 'Exposición musical',
      description:
        'Muestra tus obras musicales, artistas destacados y portafolio creativo para atraer clientes y demostrar las capacidades de tu estudio',
      enable_showcase: 'Habilitar exposición musical',
      visibility_note:
        'Crea una exposición pública visible en la página de perfil de tu organización',
      title_placeholder: 'Exposición de mi estudio',
      description_placeholder: 'Describe tu exposición musical...',
      platform_integration_note:
        'Podrás agregar música de Spotify, SoundCloud y otras plataformas a través del panel de gestión de exposiciones.',
      studio_specific_note:
        'Las exposiciones musicales están diseñadas principalmente para estudios de grabación y lugares musicales.',
      dashboard_config_note:
        'Puedes omitir este paso y configurar tu exposición musical más tarde en tu panel.',
    },
    buttons: {
      reset_to_defaults: 'Restablecer valores predeterminados',
    },
    roles: {
      custom_role: 'Rol personalizado',
    },
  },

  settings: 'Configuraciones',
  account_created_check_email:
    'Cuenta creada con exito. Verifica tu correo para completar la activación',
  verify_before_expire: 'Verificar antes de expirar',
  if_mistake_contact_instadrink: 'Si hay un error, ponte en contacto con I.D',
  invitation_rejected: 'Invitación rechazada',
  invite_owner: 'Quiero invitar a un propietario',
  invite_referrer: 'Quiero invitar a un PromoBooster',
  invite_ambassador: 'Quiero invitar a un embajador',
  invite_more_users: 'Invitar otros usuarios',
  your_organisation_staff: 'Tu personal de la organización',
  inv_org_desc: 'El organizador de tu evento',
  inv_bnc_desc: 'El controlador de acceso de tu evento',
  invite_more_staff: 'Invitar otros personal',
  since: 'desde',
  delete_event_modal: '¿Estás seguro de que quieres eliminar el evento',
  publish_event_modal: '¿Estás seguro de que quieres publicar el evento',
  cancel_event_modal: '¿Estás seguro de que quieres cancelar el evento',
  archive_event_modal: '¿Estás seguro de que quieres archivar el evento',
  duplicate_event: 'Duplicar evento',
  duplicate: 'Duplicar',
  reservations: 'Reservas',
  multiple_persons: 'Varias personas',
  persons_number: 'Número de personas',
  vatRate: 'Tipo de IVA',
  price_TTC: 'Precio con impuestos',
  Occupation: 'Ocupación',
  priceHt: 'Precio sin IVA',
  promobooster_mode: 'Modo Promobooster',
  promo_mode: 'Modo Promo',
  Amount: 'Cantidad',
  Percentage: 'Porcentaje',
  include_owners: 'Incluir dueñas',
  add_anonymous_promoter: 'Agregar SpyBooster',
  Confirm_Name: 'Confirmar nombre',
  Add_Anonymous_Name: 'Agregar SpyBooster',
  ask_for_invoice: 'pedir factura',
  add_invoice_button: 'agregar  ',
  enter_valid_invoice: 'Por favor introduce una factura válida',
  Compan_Name_Last_Name: ' Empresa/Nombre/Apellido',
  tva: 'TVA',
  adresse: 'dirección',
  postal_code: 'Código Postal',
  country: 'País',
  additional_information: 'Información adicional',
  invoice_information: 'Facturación',
  survey_information: 'Encuesta',
  know_from_invoice: '¿Qué información requieres de tu factura?',
  know_from_attendees: '¿Qué necesitas saber de tus asistentes?',
  add_invoice: 'Agregar nuevo campo',
  active_invoice: 'Activar la factura',
  actived_invoice: 'La factura está activada',
  preview_your_share: 'Vista Previa Distribución ',
  Number_of_event: 'Número de evento',
  time_of_creation: 'Crear en',
  Owner_details: 'Detalles del propietario',
  greetings: 'Saludos,',
  you_have_been_invited: 'Has sido invitado a unirte a I.D 🎉',
  plz_wait_a_moment: 'Por favor, espera un momento',
  thanks_time: 'Tiempo de agradecimientos',
  averagePreparationTime: 'Tiempo medio de preparación',
  minutes: 'minutos',
  seconds: 'segundos',
  select_menu: 'Seleccionar un menú',
  capacity_warning_message: 'Las capacidades están agotadas en comparación con la capacidad total.',
  add_product_alert:
    'Para añadir un producto a tus entradas, por favor vincula una tienda a tu evento',
  remaining_places: 'lugares restantes',
  navigate_to_event_menu: 'Ir al menú del evento',
  you_have_no_store: 'No tienes un restaurante',
  reject_order: 'Rechazar orden',
  add_Waiter: 'Añadir camarero',
  add_room: 'Añadir Habitación',
  room_name: 'Nombre De Habitación',
  campaigns: {
    title: 'Campañas de correo',
    segment: 'Segmento',
    audience: 'Audiencia',
    createNew: 'Crear nueva campaña',
    name: 'Nombre',
    template: 'Plantilla',
    scheduledTime: 'Hora programada',
    status: 'Estado',
    actions: 'Acciones',
    backToList: 'Volver a la lista de campañas',
    info: 'Información de la campaña',
    mails: 'Correos',
    email: 'Correo electrónico',
    emailStatus: 'Estado del correo',
    confirmDeletion: 'Confirmar eliminación',
    deleteConfirmationMessage:
      '¿Estás seguro de que quieres eliminar esta campaña de correo? Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar campaña',
    create: 'Crear nueva campaña',
    campaignName: 'Nombre de la campaña',
    save: 'Guardar',
    selectTemplate: 'Seleccionar una plantilla',
    createNewTemplate: 'Crear nueva plantilla',
    audienceType: {
      title: 'Audiencia',
      all: 'Todos los contactos',
      segment: 'Segmento específico',
      eventBuyers: 'Compradores de entradas',
    },
    drawer: {
      create: 'Crear Campaña',
      edit: 'Editar Campaña',
      name: 'Nombre de la Campaña',
      audienceType: 'Tipo de Audiencia',
      segment: 'Seleccionar Segmento',
      draftInfo: 'La campaña se guardará como borrador',
    },
    campaignStatus: {
      pending: 'Pendiente',
      scheduled: 'Programado',
      sending: 'Enviando',
      launched: 'Enviado',
      failed: 'Fallido',
      'template-ready': 'Plantilla listo',
    },
    emailstatus: {
      'email.sent': 'Enviado',
      'email.delivered': 'Entregado',
      'email.delivery_delayed': 'Entrega Retrasada',
      'email.complained': 'Queja Recibida',
      'email.bounced': 'Rebotado',
      'email.opened': 'Abierto',
      'email.clicked': 'Cliqueado',
      'email.unsubscribed': 'Desuscrito',
      'email.failed': 'Fallo de Envío',
      'email.blocked': 'Bloqueado',
      'email.dropped': 'Descartado',
      'email.deferred': 'Diferido',
      'email.rejected': 'Rechazado',
    },
    stats: {
      title: 'Estadísticas de la Campaña',
      delivered: 'Entregados',
      opened: 'Abiertos',
      clicked: 'Clicados',
      bounced: 'Rebotados',
    },
    subject: 'Asunto del correo',
    subjectHelperText: 'Puede personalizar el asunto de la plantilla para esta campaña',
    launchType: {
      title: 'Tipo de lanzamiento',
      immediate: 'Lanzar inmediatamente',
      scheduled: 'Programar para más tarde',
    },
    schedule: {
      action: 'Programar',
      send: 'Enviar',
      title: 'Schedule Campaign',
      info: 'Schedule sending for campaign: {{name}}',
      scheduledTimeHelper: 'Elija una fecha y hora futura para enviar su campaña',
      errors: {
        scheduleTimeRequired: 'Por favor seleccione una hora de programación',
        testEmailRequired: 'Por favor ingrese una dirección de email de prueba',
        scheduleFailed: 'Error al programar la campaña',
        testSendFailed: 'Error al enviar el email de prueba',
      },
      success: {
        testSent: 'Email de prueba enviado con éxito',
        launched: 'Campaña lanzada con éxito',
        scheduled: 'Campaña programada con éxito',
      },
    },
  },
  Include_Platform_Fees: 'Incluir tarifas de plataforma',
  Final_Price: 'Precio final',
  Platform_Fee_Info:
    'Cuando está activado, la comisión de la plataforma del 2,5% se añadirá al precio del billete y será pagada por los asistentes. Si está desactivado, esta comisión se deducirá de sus ingresos por venta de entradas.',
  Cost_to_buyers: 'Coste a los compradores',
  contacts: {
    totalContacts: '{{count}} contactos',
    import: 'Importar contactos',
    export: 'Exportar a CSV',
    deleteSelected: 'Eliminar seleccionados',
    search: 'Buscar',
    noContactsToExport: 'No hay contactos para exportar.',
    errorDeletingContacts: 'Error al eliminar contactos',
    errorLoadingContacts: 'Error al cargar contactos',
    confirmDeletion: 'Confirmar eliminación',
    confirmDeletionMessage:
      '¿Está seguro de que desea eliminar los {count} contactos seleccionados?',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    dragAndDropInstruction:
      'Arrastra y suelta un archivo CSV o XLSX aquí, o haz clic para seleccionar',
    file: 'Archivo: {name}',
    removeFile: 'Eliminar archivo',
    informationMapping: 'Mapeo de información',
    select: 'Seleccionar',
    additionalFields: 'Campos adicionales',
    errorParsingFile: 'Error al analizar el archivo. Por favor, inténtelo de nuevo.',
    contactsImportedSuccessfully: 'Contactos importados con éxito',
    errorImportingContacts: 'Error al importar contactos. Por favor, inténtelo de nuevo.',
    fields: {
      email: 'Correo electrónico',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phone: 'Teléfono',
      age: 'Edad',
      gender: 'Género',
      country: 'País',
      zone: 'Zona',
      postalCode: 'Código Postal',
    },
  },
  no_confirmed_tickets_to_export: 'No hay entradas confirmadas para exportar',
  export_confirmed_ticket_ids_tooltip: 'Exportar IDs de entradas confirmadas',
  loading: 'Cargando...',
  export_confirmed_tickets: 'Exportar Entradas Confirmadas ({{count}})',
  check_invitation_list: 'Comprueba la lista de invitaciones',
  templates: {
    createNew: 'Crear nueva plantilla',
    subject: 'Asunto del correo',
    subjectRequired: 'El asunto del correo es obligatorio',
    createSuccess: 'Plantilla creada exitosamente',
    createError: 'Error al crear la plantilla',
  },
  segments: {
    create: {
      title: 'Crear Nuevo Segmento',
      selectType: 'Seleccione un tipo de segmento',
      dynamicSegment: {
        title: 'Segmento de Filtro Dinámico',
        description:
          'Aplique una lista de atributos para seleccionar una parte de sus contactos. Sus contactos se agregarán o eliminarán automáticamente de este segmento según los filtros elegidos.',
      },
      manualSegment: {
        title: 'Segmento Manual vía CSV',
        description:
          'Puede importar una lista de contactos desde un archivo CSV para agruparlos en un segmento. Puede usar esta función para volver a importar contactos existentes como un nuevo segmento.',
      },
      step: 'Paso',
      of: 'de',
      removeFile: 'Eliminar archivo',
      newsletterContacts: '{{count}} / 2000 contactos suscritos al boletín ya importados.',
      selectAgeRange: 'Seleccione el rango de edad que desea filtrar:',
      averageAge: 'Promedio: {{age}} años',
      infoKnownFor: 'Esta información es conocida para {{count}} contactos',
      selectCountries: 'Seleccionar uno o más países',
      selectZones: 'Seleccionar zonas',
      addPostalCodes: 'Agregar códigos postales (separados por coma)',
      selectLanguage: 'Seleccionar idioma',
      whenAdded: 'Cuando este contacto fue añadido a tu comunidad',
      contactsImported: 'contactos suscritos a su boletín ya importados.',
      dropFileHere: 'Suelte su archivo CSV, XLS o XLSX aquí',
      fileRequirements:
        'Su archivo debe tener al menos una columna con la dirección de correo electrónico de los contactos. Y para enviarles boletines, debe tener una columna de suscripción al boletín (sí/no).',
      removeFilters: 'Eliminar filtros',
      contactInformation: 'INFORMACIÓN DE CONTACTO',
      marketing: 'MARKETING',
      history: 'HISTORIAL',
      fieldMapping: 'Mapeo de Campos',
      additionalFields: 'Campos Adicionales',
      segmentName: 'Nombre del Segmento',
      description: 'Descripción',
      matchingContacts: 'contactos coincidentes',
      back: 'Atrás',
      cancel: 'Cancelar',
      next: 'Siguiente',
      createSegment: 'Crear Segmento',
      importContacts: 'Importar contactos como segmento',
    },
    fieldsMapping: {
      name: 'Nombre',
      email: 'Correo',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phone: 'Teléfono',
      age: 'Edad',
      gender: 'Género',
      country: 'País',
      zone: 'Zona',
      postalCode: 'Código postal',
    },
    filters: {
      activeFilters: 'Filtros activos',
      hasEmail: 'Tiene un correo electrónico',
      emailVerified: 'Correo electrónico verificado',
      hasPhone: 'Tiene un número de teléfono',
      age: 'Edad',
      gender: 'Género',
      location: 'Ubicación',
      language: 'Idioma',
      dateAdded: 'Fecha de Agregado',
      selectCountries: 'Seleccione uno o más países',
      selectZones: 'Seleccione zonas',
      postalCodes: 'Agregar códigos postales (separados por comas)',
      selectLanguage: 'Seleccionar idioma',
      allTime: 'Todo el tiempo',
      today: 'Hoy',
      yesterday: 'Ayer',
      last7days: 'Últimos 7 días',
      last14days: 'Últimos 14 días',
      last30days: 'Últimos 30 días',
      last90days: 'Últimos 90 días',
      customDates: 'Fechas personalizadas',
      from: 'Desde',
      to: 'Hasta',
    },
  },
  segment: {
    Create: {
      matchingContacts: 'contactos coincidentes',
      back: 'Atrás',
      cancel: 'Cancelar',
      next: 'Siguiente',
      importContacts: 'Importar contactos',
      title: 'Crear segmento',
    },
  },
  // stripe_connect moved to modules/stripeConnect.es.ts
  survey: {
    title: 'Creador de Encuestas de Eventos',
    enable: 'Habilitar Encuesta',
    noResponses: 'Aún no hay respuestas',
    totalResponses: 'Respuestas totales: {{count}}',
    noSurveyData: 'No hay datos de encuesta disponibles',
    errorLoading: 'Error al cargar los datos de la encuesta',
    question: {
      title: 'Pregunta {{number}}',
      required: 'Obligatorio',
      text: 'Texto de la Pregunta',
      type: 'Tipo de Pregunta',
      types: {
        shortText: 'Texto Corto',
        longText: 'Texto Largo',
        radio: 'Botones de Radio',
        checkbox: 'Casillas de Verificación',
      },
      options: 'Opciones:',
      addOption: 'Añadir Opción',
      submit: 'Enviar Pregunta',
      validation: {
        emptyText: 'El texto de la pregunta no puede estar vacío.',
        radioOptions: 'La pregunta de opción única debe tener al menos una opción.',
        checkboxOptions: 'La pregunta de opción múltiple debe tener al menos una opción.',
      },
    },
    addQuestion: 'Añadir Pregunta',
    answersSummary: 'Resumen de Respuestas',
  },
  promoboosters: {
    referral_sales: 'Ventas por Referencia',
    other_sales: 'Otras Ventas',
    available: 'Disponible',
    No_tickets_sold_yet: 'Aún no se han vendido entradas',
    ticket_category: 'Categoría de Entrada',
    total_sold: 'Total Vendido',
    initial_quantity: 'Cantidad Inicial',
  },
  guests: {
    guestLists: 'Listas de invitados',
    addList: 'Añadir lista',
    addGuest: 'Añadir invitado',
    searchGuests: 'Buscar invitados',
    addNewList: 'Añadir nueva lista',
    listName: 'Nombre de la lista',
    guestList: 'Lista de invitados',
    sendEmailsToNewGuests: 'Enviar correos a nuevos invitados',
    single: 'Individual',
    import: 'Importar',
    text: 'Texto',
    name: 'Nombre',
    email: 'Correo',
    totalTickets: 'Entradas totales',
    freeTickets: 'Entradas gratuitas',
    dragDropCsv: 'Arrastra y suelta un archivo CSV aquí, o haz clic para seleccionar un archivo',
    guestDetailsPlaceholder:
      'Ingresa detalles de invitados (uno por línea): Nombre, EntradasTotales+EntradasGratuitas, Correo',
    importGuests: 'Importar invitados',
    editGuest: 'Editar invitado',
    update: 'Actualizar',
    delete: 'Eliminar',
    confirmDelete: 'Confirmar eliminación',
    confirmDeleteMessage:
      '¿Estás seguro de que quieres eliminar este invitado? Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    mapColumns: 'Mapear columnas',
    emailLabel: 'Correo',
    ticketsInfo: 'Entradas',
    deleteList: 'Eliminar Lista de Invitados',
    deleteListConfirmation: '¿Está seguro que desea eliminar la lista de invitados: ',
    deleteListWarning:
      ' Esto también eliminará todos los invitados en esta lista y no se puede deshacer.',
    invalidFileType:
      'Tipo de archivo no válido. Por favor, suba un archivo CSV o Excel (.csv, .xlsx, .xls)',
    csvImportInstructions:
      'Suba un archivo CSV o Excel con la información de los invitados. El archivo debe contener las siguientes columnas:',
    csvRequiredColumns: 'Columnas requeridas',
    nameColumnDescription: 'Nombre completo del invitado (obligatorio)',
    emailColumnDescription: 'Dirección de correo electrónico del invitado (opcional)',
    totalTicketsColumnDescription: 'Número total de entradas asignadas (mínimo 1)',
    freeTicketsColumnDescription:
      'Número de entradas gratuitas (debe ser menor o igual al total de entradas)',
  },
  confirm_refund: 'Confirmar reembolso',
  refund_confirmation_message:
    '¿Estás seguro de que quieres reembolsar este boleto? Esta acción no se puede deshacer.',
  refund_amount: 'Cantidad a reembolsar',
  processing: 'Procesando...',
  only_confirmed_tickets_can_be_refunded: 'Solo los boletos confirmados pueden ser reembolsados',
  refund_ticket: 'Reembolsar boleto',
  send_confirmation_email: 'Enviar correo de confirmación',
  can_only_send_email_for_confirmed_or_validated:
    'Solo se pueden enviar correos de confirmación para boletos confirmados o validados',
  deduct_platform_fee: 'Deducir Tarifa de Plataforma',
  platform_fee_toggle_description:
    'Cuando está activado, la tarifa de la plataforma se deducirá del monto del reembolso',
  'Remove Deformation': 'Remove Deformation',
  original_price: 'Precio Original',
  platform_fee: 'Tarifa de Plataforma',
  platform_fee_deduction: 'Deducción de Tarifa de Plataforma',
  final_refund_amount: 'Monto Final de Reembolso',
  'Deformed Price': 'Deformed Price',
  'Final Price': 'Final Price',
  'No deformations available': 'No price deformations available',
  'Price deformation added': 'Price deformation added successfully',
  'Price deformation removed': 'Price deformation removed',
  'Price Deformations Management': 'Price Deformations Management',
  'Add Price Deformation': 'Add Price Deformation',
  'No price deformations defined yet': 'No price deformations defined yet',
  Inactive: 'Inactive',
  off: 'off',
  Priority: 'Priority',
  Domains: 'Domains',
  'Are you sure you want to delete this price deformation?':
    'Are you sure you want to delete this price deformation?',
  'Price deformation deleted successfully': 'Price deformation deleted successfully',
  'Failed to delete price deformation': 'Failed to delete price deformation',
  'Ticket Restrictions': 'Ticket Restrictions',
  'Add Access Restriction': 'Add Access Restriction',
  'Access Restriction': 'Access Restriction',
  'Allowed Domains': 'Allowed Domains',
  'Restriction Rules': 'Restriction Rules',
  'A ticket can have either multiple price deformations OR one access restriction, but not both.':
    'A ticket can have either multiple price deformations OR one access restriction, but not both.',
  'Adding an access restriction will remove all price deformations. Continue?':
    'Adding an access restriction will remove all price deformations. Continue?',
  Access_Restriction_Description:
    'El acceso a boletos puede estar limitado según tu dominio de correo electrónico.',
  total_tickets_sold: 'Entradas vendidas',
  total_revenue: 'Ingresos totales',
  eventTicketStatistics: 'Estadísticas de entradas del evento',
  eventCapacity: 'Capacidad del evento',
  totalTickets: 'Total de entradas',
  totalReservations: 'Total de reservas',
  ticketName: 'Nombre de la entrada',
  initialQuantity: 'Cantidad inicial',
  soldQuantity: 'Cantidad vendida',
  noTicketData: 'No hay datos de entradas disponibles',
  errorLoadingTickets: 'Error al cargar los datos de las entradas',
  na: 'N/D',
  confirm_send_email: 'Confirmar envío de correo',
  send_email_confirmation_message:
    '¿Está seguro de que desea enviar el correo de confirmación a este destinatario?',
  recipient: 'Destinatario',
  sending: 'Enviando...',
  send: 'Enviar',
  ticketInvitation: {
    import: {
      csvMode: 'Importar CSV',
      singleMode: 'Importación individual',
      missingFields: 'Por favor, complete todos los campos requeridos',
      invalidEmail: 'Ingrese una dirección de correo válida',
      'success.single': 'Invitación enviada exitosamente',
      sendInvitation: 'Enviar invitación',
      numTickets: 'Número de entradas',
      steps: {
        setup: 'Configuración',
        preview: 'Vista previa e Importar',
      },
      next: 'Siguiente',
      back: 'Atrás',
      summary: 'Resumen de importación',
      totalRecords: 'Total de registros',
      selectedTicket: 'Categoría de entrada seleccionada',
      title: 'Importar invitaciones',
      progress: 'Procesando {{current}}/{{total}} ({{success}} exitosos, {{failed}} fallidos)',
      dragOrSelect: 'Suelta tu archivo CSV aquí o haz clic para seleccionar',
      dropHere: 'Suelta el archivo CSV aquí',
      mapColumns: 'Mapear columnas CSV',
      previewTitle: 'Vista previa',
      records: 'registros',
      firstThreeRecords: 'Primeros tres registros',
      importButton: 'Importar {{count}} invitaciones',
      errors: {
        unknown: 'Ocurrió un error desconocido',
        csvEmpty: 'El archivo CSV está vacío',
        invalidFormat: 'Formato CSV inválido',
        parseError: 'Error al analizar el archivo CSV',
        fileTooLarge: 'Archivo demasiado grande (máx 5MB)',
        invalidFileType: 'Solo se permiten archivos CSV',
        invalidDataRows: '{{count}} filas contienen datos inválidos',
        missingMapping: 'Por favor, mapea todas las columnas requeridas',
        creationFailed: 'Error al crear invitaciones',
      },
      success: {
        partial:
          'Importación completada: {{success}} exitosos, {{failed}} fallidos.\nDetalles:\n{{details}}',
        complete: '{{count}} invitaciones creadas exitosamente',
      },
      explanation: {
        main: 'Importe entradas para múltiples asistentes usando un archivo CSV. Perfecto para migrar desde otros sistemas de venta de entradas o crear entradas para una lista predefinida de invitados.',
        features: 'Esta herramienta de importación:',
        feature1: 'Creará entradas digitales con códigos QR únicos para cada asistente',
        feature2:
          'Enviará correos electrónicos de confirmación a los asistentes con sus códigos QR',
        feature3:
          'Permitirá asignar categorías específicas de entradas a todos los invitados importados',
      },
    },
  },
  tickets: {
    price_per_ticket_ht: 'por entrada sin IVA',
    hide_description: 'Ocultar entrada (solo visible en la página secreta)',
    validation: {
      titleRequired: 'El título es obligatorio',
      descriptionRequired: 'La descripción es obligatoria',
      priceZero: 'El precio no puede ser cero',
      priceRequired: 'El precio es obligatorio',
      initialQuantityZero: 'La cantidad inicial no puede ser cero',
      maxQuantityLimit: 'La cantidad máxima debe ser menor que la cantidad inicial',
      maxQuantityZero: 'La cantidad máxima no puede ser cero',
      minQuantityLimit: 'La cantidad mínima debe ser menor que la cantidad máxima e inicial',
      minQuantityZero: 'La cantidad mínima no puede ser cero',
      categoryRequired: 'La categoría es obligatoria',
      productRequired: 'El producto es obligatorio',
      quantityRequired: 'La cantidad es obligatoria',
      quantityGreaterThanZero: 'La cantidad debe ser mayor que cero',
      withProductRequired: 'El producto es obligatorio cuando iscomposite es verdadero',
      fieldRequired: 'Este campo es obligatorio',
      vatRateRange: 'La tasa de IVA debe estar entre 1 y 100',
    },
  },
  accessRequests: {
    request_access: 'Solicitar Acceso',
    request_access_title: 'Solicitar Acceso de Administrador',
    full_name: 'Nombre Completo',
    email: 'Correo Electrónico',
    company_name: 'Nombre de la Empresa',
    position: 'Cargo',
    reason: '¿Por qué necesita acceso?',
    cancel: 'Cancelar',
    submit: 'Enviar Solicitud',
    submitting: 'Enviando...',
    please_fill_all_fields: 'Por favor, complete todos los campos requeridos',
    invalid_email: 'Por favor, ingrese una dirección de correo válida',
    error_submitting_request: 'Error al enviar la solicitud. Por favor, intente nuevamente.',
    phone: 'Número de Teléfono',
    phone_optional: 'Opcional - Incluir código de país',
    company_optional: 'Opcional',
    position_optional: 'Opcional',
    source: '¿Cómo nos encontraste?',
    invalid_phone: 'Por favor, ingrese un número de teléfono válido',
    source_options: {
      search_engine: 'Buscador (Google, Bing, etc.)',
      social_media: 'Redes sociales',
      friend: 'Amigo o colega',
      advertisement: 'Publicidad',
      other: 'Otro',
    },
  },
  single_ticket: 'Entrada',
  Service_Fees: 'Taxas de serviço',
  Per_Ticket: 'por entrada',
  event_sales_status: 'Estado de ventas del evento',
  event_closed_for_sales: 'Este evento está actualmente cerrado para ventas',
  event_open_for_sales: 'Este evento está abierto para ventas',
  open_sales: 'Abrir ventas',
  close_sales: 'Cerrar ventas',
  confirm_open_sales: 'Confirmar apertura de ventas',
  confirm_close_sales: 'Confirmar cierre de ventas',
  open_sales_confirmation_message:
    '¿Está seguro de que desea abrir las ventas para este evento? Esto permitirá a los usuarios realizar nuevas reservas.',
  close_sales_confirmation_message:
    '¿Está seguro de que desea cerrar las ventas para este evento? Esto impedirá que los usuarios realicen nuevas reservas.',
  event_closed_warning:
    'Las ventas están actualmente cerradas para este evento. No se pueden realizar nuevas reservas hasta que se reabran las ventas.',
  Edit_Messages: 'Editar mensajes',
  multiple_tickets: 'Entradas',
  access_restrictions: 'Restricciones de acceso',
  hidden_links: 'Enlaces ocultos',
  tickets_count: 'Número de entradas',
  stop_sell_time: 'La venta se detiene a las',
  drag_drop_instruction: 'Arrastra y suelta para reordenar las entradas',
  create_tickets: 'Crea entradas para tu evento',
  access_restriction_title: 'Restricción de acceso',
  access_restriction_description: 'Gestiona quién puede acceder a tus entradas',
  add_access_restriction: 'Añadir restricción de acceso',
  inactive: 'Inactivo',
  priority: 'Prioridad',
  allowed_domains: 'Dominios permitidos',
  delete_confirmation: '¿Estás seguro de que quieres eliminar esta restricción de acceso?',
  Email_Preview: 'Vista previa del correo',
  Error_loading_email_template: 'Error al cargar la plantilla de correo',
  No_email_template_found: 'No se encontró ninguna plantilla de correo',
  No_preview_available: 'Vista previa no disponible',
  Edit_success: '¡Edición exitosa!',
  Edit_failed: '¡Falló la edición!',
  Loading: 'Cargando...',

  price_deformation: {
    name_required: 'El nombre es obligatorio',
    deformation_type_required: 'El tipo de deformación es obligatorio',
    value_required: 'El valor es obligatorio',
    value_positive: 'El valor debe ser positivo',
    invalid_value: 'Valor inválido',
    domain_required: 'Se requiere al menos un dominio',
    edit_price: 'Editar deformación de precio',
    new_price: 'Nueva deformación de precio',
    edit_access: 'Editar restricción de acceso',
    new_access: 'Nueva restricción de acceso',
    name: 'Nombre',
    description: 'Descripción',
    active: 'Activo',
    deformation_type: 'Tipo de deformación',
    percentage: 'Porcentaje',
    fixed_amount: 'Cantidad fija',
    deformation_value: 'Valor de deformación',
    email_domains: 'Dominios de correo',
    add_domain: 'Añadir dominio',
    priority: 'Prioridad',
    cancel: 'Cancelar',
    update: 'Actualizar',
    create: 'Crear',
    priority_info:
      'La prioridad determina el orden en que se aplican las restricciones. Las restricciones de mayor prioridad (número más alto) se verifican primero. Por ejemplo, una restricción con prioridad 2 se verificará antes que la prioridad 1.',
    other: 'Otro',
    condition_type: 'Tipo de restricción',
    email_domain_type: 'Dominio de correo',
    email_address_type: 'Dirección de correo',
    email_addresses: 'Direcciones de correo',
    add_email: 'Añadir correo',
    import_csv: 'Importar desde CSV',
    email_required: 'Se requiere al menos una dirección de correo',
    emails_count: '{{count}} direcciones de correo añadidas',
    max_tickets_per_email: 'Máximo de boletos por correo electrónico',
    max_tickets_placeholder: 'Dejar vacío para ilimitado',
    max_tickets_helper:
      'Limite cuántos boletos puede comprar un cliente con el mismo correo electrónico',
    max_tickets_info:
      'Establecer para limitar el número de boletos que se pueden comprar con una sola dirección de correo electrónico. Dejar vacío para no tener límite.',
    min_tickets_value: 'El valor mínimo es 1',
    integer_tickets_value: 'Por favor, introduzca un número entero',
    large_email_list_info:
      'Si tiene una lista grande de correos electrónicos, puede importarlos desde un archivo CSV. Asegúrese de que el archivo contenga una columna con las direcciones de correo electrónico.',
    showing_preview: 'Mostrando vista previa de la {{count}} plantilla de correo',
  },
  'Domain-based': 'Basado en dominio',
  'Email-based': 'Basado en email',
  'Allowed Values': 'Valores permitidos',
  Total: 'Total',
  'email addresses': 'direcciones de correo',
  'Access restrictions limit ticket purchases to specific email domains or addresses. Multiple restrictions can be active at the same time.':
    'Las restricciones de acceso limitan la compra de entradas a dominios o direcciones de correo específicos. Pueden estar activas varias restricciones al mismo tiempo.',
  'Access restrictions limit ticket purchases to specific email domains or addresses. Only one restriction can be active at a time.':
    'Las restricciones de acceso limitan la compra de entradas a dominios o direcciones de correo específicos. Solo puede estar activa una restricción a la vez.',
  'Allowed Emails': 'Correos permitidos',
  more: 'más',
  'No access restrictions have been created yet. Create one to limit ticket purchases to specific email domains or addresses.':
    'Aún no se han creado restricciones de acceso. Cree una para limitar la compra de entradas a dominios o direcciones de correo específicos.',
  'Are you sure you want to delete this access restriction?':
    '¿Está seguro de que desea eliminar esta restricción de acceso?',
  'Successfully added': 'Añadido con éxito',
  'Successfully updated': 'Actualizado con éxito',
  // Spanish translations
  bus: {
    title: 'Gestión de Autobuses',
    newTrip: 'Nuevo Viaje de Autobús',
    active: 'Activos',
    past: 'Pasados',
    all: 'Todos',
    name: 'Nombre',
    description: 'Descripción',
    route: 'Ruta',
    departureLocation: 'Lugar de Salida',
    arrivalLocation: 'Lugar de Llegada',
    duration: 'Duración',
    minutes: 'minutos',
    capacity: 'Capacidad',
    price: 'Precio',
    currency: 'Moneda',
    isRoundTrip: 'Ida y Vuelta',
    schedules: 'Horarios',
    noTripsFound: 'No se encontraron viajes de autobús',
    noSchedulesFound: 'No se encontraron horarios para este viaje',
    actions: 'Acciones',
    addSchedule: 'Añadir Horario',
    edit: 'Editar Viaje',
    delete: 'Eliminar Viaje',
    confirmDelete: '¿Está seguro de que desea eliminar este viaje de autobús?',
    confirmDeleteSchedule: '¿Está seguro de que desea eliminar este horario?',
    departureDate: 'Fecha de Salida',
    departureTime: 'Hora de Salida',
    returnDate: 'Fecha de Regreso',
    returnTime: 'Hora de Regreso',
    availableSeats: 'Asientos Disponibles',
    status: 'Estado',
    createSuccess: 'Viaje de autobús creado con éxito',
    createError: 'Error al crear el viaje de autobús',
    updateSuccess: 'Viaje de autobús actualizado con éxito',
    updateError: 'Error al actualizar el viaje de autobús',
    deleteSuccess: 'Viaje de autobús eliminado con éxito',
    deleteError: 'Error al eliminar el viaje de autobús',
    scheduleAddSuccess: 'Horario añadido con éxito',
    scheduleAddError: 'Error al añadir el horario',
    scheduleDeleteSuccess: 'Horario eliminado con éxito',
    scheduleDeleteError: 'Error al eliminar el horario',
    fetchError: 'Error al obtener los viajes de autobús',
    import: 'Importar viajes',
    importing: 'Importando viajes en bus',
    importSuccess: 'Viajes en bus importados con éxito',
    importError: 'Error al importar viajes en bus',
    parseError: 'Error al analizar el archivo JSON',
    readError: 'Error al leer el archivo',
    invalidFileType: 'Tipo de archivo no válido. Por favor, seleccione un archivo JSON',
    importBusTrips: 'Importar viajes en bus',
    previewImport: 'Vista previa de importación',
    foundTrips: '{count} viajes encontrados en el archivo',
    details: 'Detalles',
    roundTrip: 'Ida y vuelta',
    showSchedules: 'Mostrar horarios',
    hideSchedules: 'Ocultar horarios',
    importToDatabase: 'Importar a la base de datos',
    dropzoneInstructions: 'Suba un archivo JSON con datos de viajes en bus',
    dragAndDrop: 'Arrastre y suelte su archivo aquí',
    dropFileHere: 'Suelte el archivo aquí',
    orClickToSelect: 'o haga clic para seleccionar un archivo',
    onlyJsonFiles: 'Solo se admiten archivos JSON',
    direction: 'Dirección',
    tripNumber: 'Viaje N°',
    filterByDirection: 'Filtrar por dirección',
    allDirections: 'Todas las direcciones',
    outbound: 'Ida',
    return: 'Vuelta',
    aller: 'Ida',
    retour: 'Vuelta',
    allSchedules: 'Todos los horarios',
    outboundSchedules: 'Horarios de ida',
    returnSchedules: 'Horarios de vuelta',
    outboundTripNote:
      'Este viaje de ida irá de {from} a {to} con una duración de {duration} minutos.',
    returnTripNote:
      'Este viaje de vuelta irá de {from} a {to} con una duración de {duration} minutos.',
    passengerCount: 'Pasajeros',
    bookingSummary: 'Resumen de Reservas',
    overallFillRate: 'Tasa de Ocupación Global',
    totalPassengers: 'Pasajeros Totales',
    trips: 'viajes',
    passengers: 'pasajeros',
    bookingLegend: 'Leyenda de Estado de Reservas',
    plentySeats: 'Muchos asientos disponibles',
    fillingUp: 'Llenándose',
    almostFull: 'Casi lleno',
    scheduleManager: 'Administrador de Horarios',
    selectBus: 'Seleccionar Autobús',
    seats: 'asientos',
    viewSchedules: 'Ver Horarios',
    editSchedule: 'Editar Horario',
    statusActive: 'Activo',
    statusAvailable: 'Disponible',
    statusFull: 'Completo',
    statusCancelled: 'Cancelado',
    scheduleUpdateSuccess: 'Horario actualizado con éxito',
    scheduleUpdateError: 'Error al actualizar el horario',
    totalRevenue: 'Ingresos totales',
    occupancyRate: 'Tasa de ocupación',
    busStats: 'Estadísticas de autobuses',
    activeBuses: 'Autobuses activos',
    totalSales: 'Ventas totales',
    fillRate: 'Tasa de ocupación',
    totalCapacity: 'Capacidad total',
    allBuses: 'Todos los autobuses',
    observation: 'Observación',
    seatsLeft: 'asientos disponibles',
    customMessage: 'Mensaje para el cliente',
    customMessagePlaceholder:
      'Puede reservar billetes de autobús en cualquier dirección. Los billetes de regreso son gratuitos cuando compra un billete de ida.',
    customMessageHelp:
      'Este mensaje se mostrará a los clientes al seleccionar autobuses para este viaje.',
  },
  // Role translations
  roles: {
    Owner: 'Propietario',
    organizer: 'Organizador',
    promoter: 'PromoBooster',
    ambassador: 'Embajador',
    bouncer: 'Portero',
    staff: 'Personal',
  },
  join_instadrink: 'Únete a ID Network',
  join_instadrink_network: 'Únete a la red de InstaDrink',
  become_part_of_our_community: 'Forma parte de nuestra comunidad',
  i_would_like_to_invite_you_to_join_my_network: '¡Me gustaría invitarte a unirte a mi red!',
  loading_public_invite: 'Cargando enlace de invitación...',
  join_network_now: 'Unirse a la Red',
  please_fix_form_errors: 'Por favor, corrige los errores en el formulario',
  thank_you_for_joining_my_network: 'Gracias por unirte a mi red 🥂',
  i_am_a: 'Rol',
  processing_invitation_request: 'Procesando solicitud de invitación...',
  invitation_request_sent_successfully_check_your_email_finish_registration:
    'Solicitud de invitación enviada con éxito. Por favor, revisa tu correo electrónico 📧 para finalizar el registro.',
  tell_us_about_organization: 'Cuéntanos sobre tu organización',
  // Invitation translations
  invitation: {
    you_are_invited_as: 'Se le invita como',
    invitation_date: 'Fecha de invitación',
    invitation_details: 'Detalles de la invitación',
    invitation_preview: 'Vista previa de la invitación',
    please_fix_form_errors: 'Por favor, corrija los errores del formulario',
    error_loading_invitation: 'Error al cargar la invitación',
    status: {
      pending: 'Pendiente',
      accepted: 'Aceptada',
      canceled: 'Cancelada',
      rejected: 'Rechazada',
      expired: 'Caducada',
    },
    you_can_now_login: 'Ahora puedes iniciar sesión',
    redirecting_to_dashboard: 'Redirigiendo al panel de control...',
    logging_in_automatically: 'Iniciando sesión automáticamente...',
    go_to_login: 'Ir a inicio de sesión',
    account_created_successfully: 'Cuenta creada con éxito',
    by: 'por',
    password_requirements: {
      min: 'Al menos 8 caracteres',
      uppercase: 'Al menos una letra mayúscula',
      lowercase: 'Al menos una letra minúscula',
      number: 'Al menos un número',
      special: 'Al menos un carácter especial',
    },
  },
  tickets_in_reservation: 'Entradas en la reserva',
  payment_id: 'ID de pago',
  origin: 'Origen',
  bus_tickets: 'Billetes de autobús',
  type: 'Tipo',
  route: 'Ruta',
  departure_time: 'Hora de salida',
  outbound: 'Ida',
  return: 'Vuelta',
  not_specified: 'No especificado',
  invalid_date: 'Fecha inválida',
  total_bus_tickets: 'Total billetes de autobús',
  preordered: 'Preordenado',
  refunded: 'Reembolsado',
  mixed: 'Mixto',
  sent: 'Enviado',
  not_sent: 'No enviado',
  view_details: 'Ver detalles',

  reservation_details: 'Detalles de la Reserva',
  reservation_id: 'ID de Reserva',
  client: 'Cliente',

  email: 'Email',
  phone: 'Teléfono',

  payment_information: 'Información de Pago',

  total_tickets: 'Total de Entradas',

  notes: 'Notas',

  edit_reservation: 'Editar Reserva',
  edit_ticket: 'Editar Boleto',
  edit_client_information: 'Editar Información del Cliente',
  edit_ticket_info: 'Editar Información del Boleto',
  edit_reservation_info: 'Editar Información de la Reserva',
  edit_form: 'Formulario',
  select_ticket_to_edit: 'Selecciona un boleto para editar',
  client_information: 'Información del cliente',
  ticket_holder_information: 'Información del titular del boleto',
  note_client_email_unchanged: 'Nota: El correo del cliente permanece sin cambios',
  update_failed: 'Actualización fallida',

  save_changes: 'Guardar Cambios',
  saving: 'Guardando...',
  ticket_updated_successfully: 'Información del boleto actualizada con éxito',
  error_updating_ticket: 'Error al actualizar la información del boleto',
  invalid_email_format: 'Formato de correo electrónico inválido',
  ticket: {
    insurance_options: 'Opciones de garantía',
    default_insurance_description:
      'Esta garantía permite a los clientes solicitar un reembolso si no pueden asistir al evento.',
    enable_insurance: 'Habilitar opción de garantía de reembolso para clientes',
    insurance_price: 'Precio del garantía',
    max_refund_time: 'Tiempo máximo de reembolso',
    refund_time_before_event:
      'Horas antes del inicio del evento cuando el reembolso está disponible',
    insurance_description: 'Descripción del garantía',
    insurance_description_placeholder: 'Explique los términos del garantía a sus clientes',
    insurance_description_help:
      'Defina la configuración del garantía para este boleto. Los clientes podrán comprar este garantía durante el pago.',
  },
  ticketView: {
    insurance: 'garantía',
    insurance_available: 'garantía de reembolso disponible',
    insurance_price: 'Precio del garantía',
    insurance_refund_time: 'Límite de tiempo para reembolso',
    hours_before_event: 'horas antes del evento',
    insurance_description: 'Términos del garantía',
  },
  event_faqs: {
    title: 'Preguntas frecuentes del evento',
    tabs: {
      sections: 'Secciones de FAQ',
      useful_links: 'Enlaces útiles',
      contacts: 'Información de contacto',
    },
    add_section: 'Añadir sección',
    edit_section: 'Editar sección',
    section_title: 'Título de la sección',
    no_sections:
      "Aún no se han creado secciones de FAQ. Haz clic en 'Añadir sección' para crear tu primera sección.",
    items_count: '{{count}} preguntas',
    add_item: 'Añadir pregunta',
    edit_item: 'Editar pregunta',
    question: 'Pregunta',
    answer: 'Respuesta',
    no_items: 'Aún no hay preguntas en esta sección',
    confirm_delete_section:
      '¿Estás seguro de que quieres eliminar esta sección? Todas las preguntas de esta sección serán eliminadas.',
    confirm_delete_item: '¿Estás seguro de que quieres eliminar esta pregunta?',

    add_link: 'Añadir enlace',
    edit_link: 'Editar enlace',
    link_title: 'Título del enlace',
    link_url: 'URL',
    no_links:
      "Aún no se han creado enlaces útiles. Haz clic en 'Añadir enlace' para crear tu primer enlace.",
    confirm_delete_link: '¿Estás seguro de que quieres eliminar este enlace?',
    invalid_url: 'Por favor, introduce una URL válida (ej: https://ejemplo.com)',

    add_contact: 'Añadir contacto',
    edit_contact: 'Editar contacto',
    contact_name: 'Nombre',
    contact_role: 'Rol',
    contact_email: 'Email',
    contact_phone: 'Teléfono',
    no_contacts:
      "Aún no se han creado contactos. Haz clic en 'Añadir contacto' para crear tu primer contacto.",
    confirm_delete_contact: '¿Estás seguro de que quieres eliminar este contacto?',
    invalid_email: 'Por favor, introduce una dirección de email válida',
  },
  ticketsStats: {
    timeAnalysis: 'Análisis Temporal',
    dailySalesVelocity: 'Velocidad de Ventas Diarias',
    hourlySalesVelocity: 'Velocidad de Ventas por Hora',
    peakDays: 'Días Pico de Ventas',
    peakHours: 'Horas Pico de Ventas',
    ticketsSold: 'Entradas Vendidas',
    salesCount: 'Cantidad de Ventas',
    revenue: 'Ingresos',
    noTimeData: 'No hay datos temporales disponibles',
    noHourlyDataForSelectedDay: 'No hay datos por hora disponibles para el día seleccionado',
    noTicketData: 'No hay datos de entradas disponibles para el análisis',
    day: 'Día',
    hour: 'Hora',
    selectDay: 'Seleccionar Día',
    peakPeriods: 'Periodos Pico',
  },
  artistLineup: {
    title: 'Alineación de Artistas',
    manageLineup: 'Administrar Alineación de Artistas',
    currentLineup: 'Alineación Actual',
    noArtists: 'Aún no se han añadido artistas a este evento.',
    addFirstArtist: 'Añadir Tu Primer Artista',
    addArtist: 'Añadir Artista',
    editArtist: 'Editar Artista',
    removeSuccess: 'Artista eliminado exitosamente',
    addSuccess: 'Artista añadido exitosamente',
    updateSuccess: 'Artista actualizado exitosamente',
    reorderSuccess: 'Alineación reordenada exitosamente',
    confirmRemove: '¿Estás seguro de querer eliminar este artista?',
    artistName: 'Nombre del Artista',
    performanceTime: 'Hora de Actuación',
    biography: 'Biografía',
    imageUrl: 'URL de Imagen del Artista',
    socialLinks: 'Redes Sociales',
    website: 'Sitio Web',
    followers: 'seguidores',
    viewOnSpotify: 'Ver en Spotify',
    generateLink: 'Compartir con Plataformas Musicales',
    shareMusicPlatform: 'Compartir con Plataformas Musicales',
    shareInfo:
      'Comparte estos enlaces con plataformas musicales para ayudar a promocionar tu evento. El enlace de reserva es para que los usuarios compren entradas, mientras que el enlace API proporciona datos del evento para que las plataformas se integren.',
    bookingLinkTitle: 'Enlace de Reserva (Para Usuarios)',
    apiLinkTitle: 'Enlace API (Para Plataformas Musicales)',
    securityNote: 'Nota de Seguridad',
    securityDetails:
      'Estos enlaces incluyen un token de seguridad único para tu evento. Puedes regenerar el enlace en cualquier momento si es necesario.',
    linkCopied: 'Enlace copiado al portapapeles',
    searchArtist: 'Buscar Artista en Spotify',
    searchSpotify: 'Buscar un artista en Spotify',
    addArtistDetails: 'Añadir Detalles del Artista',
    manualEntry: '¿No encuentras tu artista? Añádelo manualmente:',
    addManually: 'Añadir Artista Manualmente',
    artistFound:
      '¡Artista encontrado en Spotify! Completa cualquier detalle adicional a continuación.',
    noResults: 'No se encontraron artistas con ese nombre',
    performsAt: 'Actúa a las',
    notifySubscribers: 'Notificar a Seguidores del Artista',
    notifySuccess: 'Notificación enviada exitosamente',
    confirmNotify:
      'Esto notificará a los suscriptores de los artistas de Spotify en tu alineación sobre tu evento. ¿Continuar?',
  },
  passculture: {
    subtitle: 'Integración con Pass Culture',
    eventDetails: 'Detalles del evento',
    category: 'Categoría',
    date: 'Fecha',
    time: 'Hora',
    venue: 'Lugar',
    saveVenue: 'Guardar lugar',
    venueSaved: 'Lugar guardado',
    venueId: 'ID del lugar',
    passCultureInfo: 'Información de Pass Culture',
    publishedOn: 'Publicado el',
    passCultureId: 'ID en Pass Culture',
    status: 'Estado',
    passCultureIntegration: 'Integración con Pass Culture',
    notPublishedYet: 'Este evento aún no ha sido publicado en Pass Culture.',
    publishInfo:
      'La publicación en Pass Culture hará que este evento esté disponible para los usuarios elegibles de la plataforma Pass Culture.',
    description: 'Descripción',
    currentStatus: 'Estado actual',
    venueSelectionHelp:
      'Seleccione un lugar existente o cree uno nuevo para este evento. El lugar debe estar registrado en Pass Culture para que el evento se publique correctamente.',
    passCultureDetails: 'Detalles de Pass Culture',
    lastUpdated: 'Última actualización',
    bookingsCount: 'Reservas',
    remainingStock: 'Stock restante',
    publicationDate: 'Fecha de publicación',
    lastModified: 'Última modificación',
    rejectionReason: 'Motivo de rechazo',
    rawResponse: 'Datos sin procesar de Pass Culture',
    unknown: 'Desconocido',
    noStatusData:
      'No hay datos de estado disponibles. Verifique el estado para obtener información actualizada.',
    checkStatus: 'Verificar estado',
    ticketsMapping: 'Mapeo de entradas',
    ticketsMappingDescription:
      'Esta tabla muestra cómo se mapean las entradas del evento a las categorías de Pass Culture.',
    price: 'Precio',
    available: 'Disponible',
    passCultureCategory: 'Categoría en Pass Culture',
    notMapped: 'No mapeado',
    ticketsMappingNote:
      'Solo las entradas disponibles para la venta se mapearán a las categorías de Pass Culture.',
    noTicketsAvailable: 'No hay entradas disponibles para este evento.',
    ticketInfo: 'Información de entradas',
    moreCategories: 'Y más categorías...',
    publish: 'Publicar en Pass Culture',
    refreshStatus: 'Actualizar estado',
    publishDialog: {
      title: 'Publicar en Pass Culture',
      description:
        '¿Está seguro de que desea publicar este evento en Pass Culture? Una vez publicado, el evento estará disponible para los usuarios elegibles de Pass Culture.',
      warning:
        'Nota: La publicación en Pass Culture está sujeta a revisión por parte de su equipo y puede tardar algo de tiempo en aparecer en su plataforma.',
    },
    tabs: {
      overview: 'Resumen',
      status: 'Estado',
      tickets: 'Entradas',
    },
    events: {
      notPublished: 'No publicado',
      publishError: 'Error de publicación',
      published: 'Publicado',
    },
    success: {
      eventPublished: '¡{{name}} ha sido publicado con éxito en Pass Culture!',
      statusRefreshed: 'El estado se ha actualizado correctamente.',
      emailSaved: 'Correo electrónico de contacto guardado correctamente',
      stocksAdded: 'Las existencias se han añadido con éxito a Pass Culture',
    },
    errors: {
      eventNotFound: 'Evento no encontrado o no tiene permisos para verlo.',
      publishEventFailed:
        'Error al publicar el evento en Pass Culture. Por favor, inténtelo de nuevo.',
      refreshStatusFailed:
        'Error al actualizar el estado del evento. Por favor, inténtelo de nuevo.',
      invalidEmail: 'Por favor, introduzca una dirección de correo electrónico válida',
      noContactEmail: 'Por favor, proporcione un correo electrónico de contacto antes de publicar',
      addStocksFailed: 'Error al añadir existencias a Pass Culture',
    },
    contactEmail: 'Correo electrónico de contacto',
    contactEmailHelp:
      'Por favor, proporcione un correo electrónico de contacto para los usuarios de Pass Culture. Este correo electrónico se mostrará a los usuarios en la plataforma Pass Culture.',
    email: 'Correo electrónico',
    comingSoon: {
      title: 'Integración con Pass Culture',
      message:
        'La integración con Pass Culture estará disponible próximamente. Esta función le permitirá publicar sus eventos en la plataforma Pass Culture. ¡Esté atento a las actualizaciones!',
    },
    addStocks: 'Añadir existencias',
    stocksInformation: 'Información de existencias',
    stocksAddedSuccess: 'Se han añadido {{count}} existencias con éxito a Pass Culture',
    stocksCount: 'Total de existencias',
    lastStockUpdate: 'Última actualización',
    warnings: {
      noStocks: 'Aún no se han añadido existencias a este evento en Pass Culture',
      noTicketsFound:
        'No se encontraron boletos para este evento. Por favor, cree boletos antes de añadir existencias.',
    },
    stocks: {
      dialogTitle: 'Añadir existencias a Pass Culture',
      step1: 'Configurar existencias',
      step1Description: 'Elige cómo quieres añadir existencias a Pass Culture para este evento.',
      step2: 'Confirmar y crear',
      step2Description: 'Revisa tu selección y crea las existencias en Pass Culture.',
      step3: 'Éxito',
      step3Description: 'Tus existencias se han creado con éxito en Pass Culture.',
      useExistingTickets: 'Usar boletos existentes de mi evento',
      ticketsFound: 'Boletos encontrados',
      ticketsDescription:
        'Los boletos de tu evento se asignarán automáticamente a las categorías de precios de Pass Culture.',
      willUseExistingTickets: 'Crearás {{count}} existencias basadas en tus boletos existentes',
      willCreateCustomStocks: 'Crearás existencias personalizadas en Pass Culture',
      createStocks: 'Crear existencias',
      successMessage: 'Las existencias se han creado con éxito en Pass Culture',
    },
  },
  passculturedocumentation: {
    title: 'Integração Pass Culture',
    category: 'Configuração de Eventos',
    intro:
      'Pass Culture é uma iniciativa do governo francês que fornece vouchers culturais para jovens. Ao integrar com Pass Culture, você pode tornar seus eventos acessíveis aos usuários do Pass Culture e expandir seu alcance de audiência. Este guia irá orientá-lo através do processo completo de configuração para integrar eventos individuais com Pass Culture.',
    important: 'Importante:',
    eventLevelConfig:
      'A integração Pass Culture é configurada no nível do evento. Cada evento que você deseja disponibilizar no Pass Culture precisa ser configurado individualmente através de sua própria aba Pass Culture.',

    whatIs: {
      title: 'O que é Pass Culture?',
      description:
        'Pass Culture é uma plataforma digital que oferece créditos culturais para jovens de 15-20 anos na França. Os usuários recebem vouchers que podem ser usados para comprar produtos e serviços culturais, incluindo:',
      services: {
        concerts: 'Concertos e eventos musicais',
        theater: 'Ingressos de teatro e cinema',
        books: 'Livros e workshops culturais',
        exhibitions: 'Exposições de arte e experiências culturais',
      },
    },

    benefits: {
      title: 'Benefícios da Integração',
      youngAudience: 'Alcançar audiências jovens (15-20 anos)',
      governmentBacked: 'Sistema de pagamento apoiado pelo governo',
      visibility: 'Maior visibilidade de eventos',
      guaranteedPayments: 'Pagamentos garantidos',
    },

    prerequisites: {
      title: 'Pré-requisitos',
      description:
        'Antes de poder integrar com Pass Culture, você precisa atender certos requisitos e ter informações específicas prontas.',
      business: {
        title: 'Informações Comerciais Necessárias',
        siren: 'Número SIREN ou SIRET',
        sirenDesc: 'Seu número oficial de registro comercial francês',
        legalEntity: 'Entidade comercial legal',
        legalEntityDesc: 'Deve ser um negócio registrado na França',
        license: 'Licença de atividade cultural',
        licenseDesc: 'Licenciamento apropriado para organização de eventos culturais',
      },
      account: {
        title: 'Configuração da Conta Pass Culture',
        register: 'Registrar no Pass Culture Pro',
        registerDesc: 'Criar uma conta em https://passculture.pro',
        verification: 'Completar verificação comercial',
        verificationDesc: 'Enviar documentos necessários para aprovação',
        apiAccess: 'Aprovação de acesso API',
        apiAccessDesc: 'Aguardar aprovação da equipe Pass Culture para acesso API',
      },
    },

    integration: {
      title: 'Guia de Configuração de Integração',
      description:
        'Siga estes passos para integrar Pass Culture com sua organização Instadrink. Certifique-se de ter completado os pré-requisitos antes de começar.',
    },

    steps: {
      businessId: {
        title: 'Adicionar Seu Identificador Comercial',
        description:
          'Primeiro, você precisa adicionar seu número SIREN ou SIRET ao perfil de sua organização no Instadrink.',
        step1: 'Ir para Configurações da Organização → Informações Gerais',
        step2: 'Digite seu número SIREN (9 dígitos) ou SIRET (14 dígitos)',
        step3: 'Salvar as configurações de sua organização',
        warning:
          'Seu número SIREN/SIRET deve corresponder exatamente com o registrado em sua conta Pass Culture Pro.',
      },
      access: {
        title: 'Acessar Integração Pass Culture',
        description: 'Navegar para a seção de integração Pass Culture para seu evento específico.',
        step1: 'Ir para seu Painel de Controle de Eventos',
        step2: "Clicar na aba 'Pass Culture' nas configurações do evento",
        step3: 'Você verá o número SIREN/SIRET de sua organização exibido',
        step4: "A integração mostrará como ambiente 'Integração' por padrão",
      },
      venue: {
        title: 'Selecionar Local do Evento',
        description:
          'Uma vez na aba Pass Culture, você verá locais disponíveis baseados no número SIREN/SIRET de sua organização. Selecione o local onde este evento específico acontecerá.',
        step1: 'Na aba Pass Culture, você verá um menu suspenso de seleção de local',
        step2:
          'Locais disponíveis são carregados automaticamente baseados no SIREN/SIRET de sua organização',
        step3: 'Selecionar o local onde seu evento acontecerá do menu suspenso',
        step4: 'Revisar detalhes do local (endereço, acessibilidade, etc.) que aparecem à direita',
        step5: "Clicar 'Salvar Local' para vincular este local ao seu evento",
        noVenuesInfo:
          'Se nenhum local aparecer, você pode precisar sincronizar com Pass Culture primeiro (ver próximo passo) ou verificar se o SIREN/SIRET de sua organização está corretamente configurado e tem locais associados no Pass Culture.',
      },
      eventDetails: {
        title: 'Preparar Detalhes do Evento para Publicação',
        description:
          'Agora que você selecionou um local, precisa preparar dois elementos-chave antes de poder publicar seu evento no Pass Culture.',
        importantNote:
          'Apenas dois campos são necessários neste passo: descrição do evento e email de contato. No entanto, seu evento também deve ter ingressos com categorias PassCulture para habilitar a publicação.',
        requiredInfo: 'Informações de Evento Necessárias:',
        eventDescription: 'Descrição do Evento para Pass Culture',
        eventDescriptionTip:
          'Adapte sua descrição para atrair jovens de 15-20 anos. Use linguagem envolvente e acessível e destaque o que torna seu evento especial.',
        contactEmail: 'Email de Contato para Usuários Pass Culture',
        contactEmailTip:
          'Forneça um endereço de email específico onde usuários Pass Culture podem contatá-lo com perguntas sobre seu evento.',
        ticketRequirement: 'Requisito Crítico - Categorias de Ingressos PassCulture:',
        veryImportant: 'Muito Importante:',
        ticketWarning:
          'Para publicar um evento no Pass Culture, seu evento deve ter ingressos com categorias PassCulture. O botão publicar permanecerá desabilitado até que esta condição seja atendida.',
        createCategories: 'Criar Categorias de Ingressos PassCulture',
        createCategoriesDesc:
          "Ir para a aba Ingressos do seu evento → Categorias, e criar pelo menos uma categoria com 'Integração PassCulture' habilitada",
        enableIntegration: 'Habilitar Integração PassCulture',
        enableIntegrationDesc:
          "Ao criar ou editar uma categoria de ingresso, ativar a configuração 'Integração PassCulture'",
        createTickets: 'Criar Ingressos com Categorias PassCulture',
        createTicketsDesc:
          'Certifique-se de ter ingressos ativos atribuídos a essas categorias habilitadas PassCulture',
        publishingConditions: 'Condições de Publicação:',
        condition1: 'Descrição do evento preenchida e otimizada para audiência jovem',
        condition2: 'Email de contato válido fornecido',
        condition3: 'Pelo menos uma categoria de ingresso tem integração PassCulture habilitada',
        condition4: 'Evento tem ingressos ativos usando categorias PassCulture',
        condition5: 'Data do evento é pelo menos 15 dias no futuro',
        condition6: 'Preços dos ingressos estão dentro dos limites Pass Culture (máx €300)',
        proTip:
          'Se o botão publicar permanecer desabilitado após preencher o formulário, verifique se você criou categorias de ingressos com Integração PassCulture habilitada na aba Ingressos.',
        writingTips:
          'Use palavras-chave como "estudantes", "jovens artistas", mencione preços especiais ou descontos estudantis, e destaque aspectos sociais/culturais que atraiam jovens de 15-20 anos.',
      },
    },

    proTip: 'Dica Pro:',
    writingTips: 'Dicas de Escrita para Audiência Jovem:',

    venuesOfferers: {
      title: 'Entendendo Locais e Oferentes',
      offerer: {
        title: 'Oferente',
        description:
          'O oferente representa sua organização/entidade comercial no Pass Culture. Contém suas informações comerciais e está vinculado ao seu número SIREN.',
        includes: 'Oferente inclui:',
        item1: 'Nome comercial e informações legais',
        item2: 'Número SIREN',
        item3: 'Data de criação da conta',
        item4: 'Status de validação',
      },
      venues: {
        title: 'Locais',
        description:
          'Locais são os lugares físicos onde seus eventos acontecem. Cada local tem informações específicas e detalhes de acessibilidade.',
        includes: 'Cada local inclui:',
        item1: 'Nome e endereço do local',
        item2: 'Número SIRET (se aplicável)',
        item3: 'Informações de acessibilidade',
        item4: 'Domínio de atividade',
      },
    },

    troubleshooting: {
      title: 'Solucionando Problemas Comunes',
      solutions: 'Soluciones:',
      noVenues: {
        title: 'Error "No se encontraron lugares"',
        description:
          'Esto usualmente significa que su SIREN/SIRET no se encuentra en Pass Culture o no tiene lugares asociados.',
        solution1: 'Verifique que su número SIREN/SIRET sea correcto',
        solution2: 'Verifique que ha completado la configuración de lugar en Pass Culture Pro',
        solution3: 'Contacte el soporte Pass Culture para verificar el estado de su cuenta',
      },
      syncFailed: {
        title: 'Error "Fallo de sincronización"',
        description:
          'Problemas de red o autenticación que impiden la sincronización con la API Pass Culture.',
        solution1: 'Verifique su conexión a internet e intente de nuevo',
        solution2: 'Espere unos minutos y reintente la sincronización',
        solution3: 'Contacte el soporte Instadrink si el problema persiste',
      },
      needSiren: {
        title: 'Advertencia "Necesita SIREN o SIRET"',
        description: 'El perfil de su organización no tiene un número SIREN o SIRET configurado.',
        solution1: 'Ir a Configuración Organización → Información General',
        solution2: 'Agregar su número SIREN de 9 dígitos o SIRET de 14 dígitos',
        solution3: 'Guardar configuración y regresar a integración Pass Culture',
      },
      eventsNotAppearing: {
        title: 'Eventos no apareciendo en Pass Culture',
        description: 'Sus eventos están creados pero no visibles en la plataforma Pass Culture.',
        solution1:
          'Asegúrese de haber seleccionado un lugar Pass Culture para su evento en la pestaña Pass Culture del evento',
        solution2: 'Verifique que su evento cumple los criterios de elegibilidad Pass Culture',
        solution3: 'Verifique que está en entorno de producción (no integración)',
        solution4: 'Espere 24-48 horas para moderación Pass Culture',
      },
    },

    bestPractices: {
      title: 'Mejores Prácticas',
      regularSync: {
        title: 'Sincronización Regular',
        description:
          'Sincronice sus lugares regularmente para asegurar que tiene la información más reciente de Pass Culture, especialmente si ha agregado nuevos lugares o actualizado existentes.',
      },
      testThoroughly: {
        title: 'Pruebe Minuciosamente',
        description:
          'Siempre pruebe sus eventos en el entorno de integración antes de pasar a producción. Esto ayuda a detectar problemas temprano y asegura una experiencia fluida para los usuarios.',
      },
      targetAudience: {
        title: 'Audiencia Objetivo',
        description:
          'Recuerde que los usuarios Pass Culture tienen entre 15-20 años. Adapte sus descripciones de eventos y marketing para atraer a esta demografía más joven.',
      },
    },

    eventRequirements: {
      title: 'Requisitos de Eventos Pass Culture',
      description:
        'No todos los eventos son elegibles para Pass Culture. Asegúrese de que sus eventos cumplan estos criterios:',
      eligible: {
        title: 'Tipos de Eventos Elegibles',
        concerts: 'Conciertos y presentaciones musicales en vivo',
        theater: 'Espectáculos de teatro y presentaciones dramáticas',
        artExhibitions: 'Exposiciones de arte y talleres culturales',
        literaryEvents: 'Eventos literarios y presentaciones de libros',
        photography: 'Exposiciones de fotografía y multimedia',
        cinema: 'Proyecciones de cine y festivales de películas',
      },
      nonEligible: {
        title: 'Tipos de Eventos No Elegibles',
        sports: 'Eventos deportivos y competencias',
        business: 'Conferencias de negocios y seminarios',
        privateParties: 'Fiestas privadas y celebraciones',
        commercial: 'Lanzamientos de productos comerciales',
        religious: 'Eventos religiosos o políticos',
        educational: 'Cursos educativos o entrenamientos',
      },
      additional: {
        title: 'Requisitos Adicionales',
        timing: 'Temporización',
        timing1: 'Los eventos deben publicarse al menos 15 días antes de la fecha del evento',
        timing2: 'Las reservas deben cerrar al menos 2 horas antes del inicio del evento',
        pricing: 'Precios',
        pricing1: 'Precio máximo de entrada: €300',
        pricing2: 'Los eventos gratuitos están permitidos y son alentados',
      },
    },

    support: {
      title: 'Soporte y Recursos',
      links: {
        title: 'Enlaces Útiles',
        pro: 'Pass Culture Pro',
        proDesc: 'https://passculture.pro - Plataforma principal para proveedores culturales',
        documentation: 'Documentación Pass Culture',
        documentationDesc: 'Documentación API oficial y directrices',
        app: 'App Pass Culture',
        appDesc: 'Descargue la app para ver cómo aparecen sus eventos a los usuarios',
      },
      help: {
        title: 'Obtener Ayuda',
        instadrink: 'Soporte Instadrink',
        instadrinkDesc: 'support@instadrink.com - Para problemas técnicos de integración',
        passculture: 'Soporte Pass Culture',
        passcultureDesc:
          'Contacte a través de la plataforma Pass Culture Pro para problemas de cuenta',
        liveChat: 'Chat en Vivo',
        liveChatDesc: 'Use el widget de chat en su panel de control Instadrink',
      },
    },

    faq: {
      title: 'Preguntas Frecuentes',
      q1: {
        question: 'P: ¿Cuánto tiempo toma ser aprobado para Pass Culture?',
        answer:
          'R: El proceso de aprobación típicamente toma 2-4 semanas después de enviar todos los documentos requeridos. Las pruebas y validación pueden agregar otras 1-2 semanas antes de la aprobación de producción.',
      },
      q2: {
        question: 'P: ¿Puedo usar Pass Culture si no estoy basado en Francia?',
        answer:
          'R: Pass Culture es específicamente para proveedores culturales que operan en Francia. Necesita un número SIREN/SIRET francés y sus eventos deben tener lugar en Francia.',
      },
      q3: {
        question: 'P: ¿Qué pasa si mi evento es cancelado?',
        answer:
          'R: Si cancela un evento, los usuarios Pass Culture serán automáticamente reembolsados. Debe cancelar el evento tanto en Instadrink como notificar a Pass Culture lo antes posible.',
      },
      q4: {
        question: 'P: ¿Cómo recibo pagos de reservas Pass Culture?',
        answer:
          'R: Pass Culture maneja los pagos directamente y transfiere fondos a su cuenta bancaria según su cronograma de pagos. Configurará detalles bancarios en su cuenta Pass Culture Pro.',
      },
      q5: {
        question: 'P: ¿Puedo modificar eventos después de ser publicados en Pass Culture?',
        answer:
          'R: Sí, pero los cambios están sujetos a las políticas de Pass Culture. Cambios mayores como fecha, hora o lugar pueden requerir re-aprobación. Los aumentos de precio generalmente no están permitidos después de la publicación.',
      },
    },

    readyToStart: {
      title: '¿Listo para Comenzar?',
      description:
        'Ahora que entiende cómo funciona la integración Pass Culture, ¡está listo para comenzar el proceso de configuración! Comience asegurándose de tener su número SIREN o SIRET, luego siga la guía paso a paso arriba.',
      button: 'Comenzar Configuración de Integración',
    },
  },

  dashboard: 'Panel de control',
  organizers: 'Organizadores',
  organizerDetails: 'Detalles del organizador',
  generalInfo: 'Información general',
  backToOrganizers: 'Volver a organizadores',
  backToOrganizer: 'Volver al organizador',
  organizerNotFound: 'Organizador no encontrado',
  failedToFetchOrganizer: 'Error al obtener datos del organizador',

  // Integration specific
  integrations: 'Integraciones',
  integrationsPageDescription:
    'Conecte su organizador con servicios externos para mejorar sus eventos y llegar a más clientes.',
  comingSoon: 'Próximamente',
  integrationComingSoon:
    'La integración con {name} está actualmente en desarrollo y estará disponible próximamente.',

  // Integration descriptions
  passCultureIntegrationDescription:
    'Pass Culture es una aplicación móvil y un sitio web que ofrece 300€ a jóvenes de 18 años para gastar en bienes y experiencias culturales. Conecte su organizador para importar automáticamente lugares y publicar sus eventos.',
  ticketingIntegrationDescription:
    'Conecte su organizador con plataformas populares de venta de entradas para sincronizar datos de eventos, gestionar ventas de entradas y seguir la asistencia a través de múltiples canales.',
  crmIntegrationDescription:
    'Integre sistemas de gestión de relaciones con clientes para administrar su base de clientes, seguir el historial de comunicaciones y crear campañas de marketing para sus eventos.',

  // Tab labels
  ticketing: 'Venta de entradas',

  // Pass Culture specific translations
  passCultureIntegration: 'Integración con Pass Culture',
  identifier: 'Identificador',
  noIdentifier: 'Sin identificador configurado',
  lastSynced: 'Última sincronización',
  venues: 'Espacios',
  offerer: 'Ofertante',
  syncWithPassCulture: 'Sincronizar con Pass Culture',
  passCultureVenues: 'Espacios de Pass Culture',
  passCultureOfferer: 'Ofertante de Pass Culture',
  syncResults: 'Resultados de sincronización',
  noVenuesFound: 'No se encontraron espacios',
  noOffererData: 'Datos del ofertante no disponibles',
  syncedVenues: '{{count}} espacios sincronizados con éxito',
  passCultureSyncSuccess: '{{count}} espacios sincronizados con éxito con Pass Culture',
  passCultureSyncFailed: 'Error al sincronizar con Pass Culture',
  syncFailed: 'La sincronización falló',
  needSirenOrSiret:
    'El organizador necesita un número SIREN o SIRET para sincronizarse con Pass Culture',
  close: 'Cerrar',
  never: 'Nunca',
  siren: 'SIREN',
  createdAt: 'Creado el',
  additionalInfo: 'Información adicional',
  notAvailable: 'No disponible',
  goodies: {
    // Section Headers
    section: {
      title: 'Productos del Evento',
      description:
        'Gestione los productos que los clientes pueden comprar al reservar entradas para este evento.',
    },

    // Actions
    actions: {
      new: 'Añadir Producto',
      edit: 'Editar Producto',
      add: 'Añadir Producto',
      save: 'Guardar Cambios',
      create: 'Crear Producto',
      delete: 'Eliminar Producto',
      delete_confirm:
        '¿Está seguro de que desea eliminar este producto? Esta acción no se puede deshacer.',
      manage: 'Gestionar Productos',
      hide: 'Ocultar Productos',
      clear_cart: 'Vaciar Carrito',
      checkout: 'Finalizar Compra',
      add_to_cart: 'Añadir al Carrito',
      adding: 'Añadiendo...',
      remove: 'Quitar',
      close: 'Cerrar',
    },

    // Table Headers
    table: {
      name: 'Nombre',
      price: 'Precio',
      stock: 'Existencias',
      active: 'Activo',
      selected: 'seleccionado(s)',
      search: 'Buscar producto...',
    },

    // Form Fields
    form: {
      name: 'Nombre',
      description: 'Descripción',
      price: 'Precio',
      stock: 'Existencias',
      image: 'Imagen',
      active: 'Activo',
      in_stock: 'En existencias',
      out_of_stock: 'Agotado',
      quantity: 'Cantidad',
    },

    // Cart
    cart: {
      title: 'Sus Productos',
      subtotal: 'Subtotal',
      checkout_notice: 'Los productos se añadirán a su reserva de entradas.',
      increase_quantity: 'Aumentar Cantidad',
      decrease_quantity: 'Disminuir Cantidad',
      open: 'Abrir Carrito',
    },

    // Tooltips
    tooltips: {
      name: 'Introduzca el nombre del producto',
      description: 'Proporcione una descripción detallada del producto',
      price: 'Establezca el precio de este producto',
      stock: 'Introduzca la cantidad disponible de este producto',
      image: 'Suba una imagen del producto',
      active: 'Active para hacer que este producto esté disponible para su compra',
    },

    // Errors
    errors: {
      loading: 'Error al cargar los productos',
      none_available: 'No hay productos disponibles para este evento',
    },

    // Language tabs
    languages: 'Pestañas de traducción (Inglés, Francés, Español, Portugués, Alemán)',
  },
  common: {
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    yes: 'Sí',
    no: 'No',
    ok: 'Aceptar',
    close: 'Cerrar',
    none: 'Ninguno',
  },
  participantInfos: {
    know_from_attendees: '¿Cómo conociste el evento?',
    add_custom_field: 'Añadir campo personalizado',
    field_name: 'Nombre del campo',
    field_type: 'Tipo de campo',
    add_field: 'Añadir campo',
    options: 'Opciones',
    add_option: 'Añadir opción',
    add: 'Añadir',
    Text: 'Texto',
    Number: 'Número',
    Email: 'Correo electrónico',
    Phone: 'Teléfono',
    Date: 'Fecha',
    'Multiple Choice': 'Opción múltiple',
    Dropdown: 'Desplegable',
    Checkbox: 'Casilla de verificación',
    type: 'Tipo',
    Edit_data_success: '¡Datos actualizados con éxito!',
    Edit_data_failed: '¡Error al actualizar los datos!',
    no_options_added: 'No se han añadido opciones',
    edit: 'Editar',
    options_for: 'Opciones para',
    enter_option_placeholder: 'Introduce una opción y pulsa Enter o Añadir',
    multiple_choice_helper_text: 'Los asistentes podrán seleccionar una opción de la lista.',
    dropdown_helper_text: 'Los asistentes verán un menú desplegable para seleccionar una opción.',
    checkbox_helper_text: 'Los asistentes podrán seleccionar múltiples opciones de la lista.',

    'Single Choice': 'Opción única',
    single_choice_explanation: 'Los asistentes podrán seleccionar SOLO UNA opción de la lista.',
    multiple_choice_explanation: 'Los asistentes podrán seleccionar VARIAS opciones de la lista.',
    minimum_options_warning: 'Necesitas al menos 2 opciones para este tipo de pregunta.',
  },
  'Multi-day Festival Ticket': 'Boleto Festival Multi-día',
  'Allow ticket to be validated once per festival day':
    'Permitir validación una vez por día de festival',
  'Multi-day Festival Configuration': 'Configuración Festival Multi-día',
  'This ticket can be validated once per festival day. Validations reset daily at the specified time.':
    'Este boleto puede validarse una vez por día de festival. Las validaciones se reinician diariamente a la hora especificada.',
  Example: 'Ejemplo',
  'Festival June 10-13, reset at 02:00 means:':
    'Festival 10-13 junio, reinicio a las 02:00 significa:',
  'Day 1: June 10 from event start until June 11 02:00':
    'Día 1: 10 junio desde inicio del evento hasta 11 junio 02:00',
  'Day 2: June 11 02:00 until June 12 02:00': 'Día 2: 11 junio 02:00 hasta 12 junio 02:00',
  'Day 3: June 12 02:00 until June 13 02:00': 'Día 3: 12 junio 02:00 hasta 13 junio 02:00',
  'Day 4: June 13 02:00 until event end': 'Día 4: 13 junio 02:00 hasta fin del evento',
  'Daily Reset Time': 'Hora de Reinicio Diario',
  'Time when daily validations reset (24h format). Recommended: 02:00 for festivals':
    'Hora cuando las validaciones diarias se reinician (formato 24h). Recomendado: 02:00 para festivales',
  'Invalid time format. Use HH:MM (24h format)':
    'Formato de hora inválido. Use HH:MM (formato 24h)',
  studio: {
    customization: {
      title: 'Personalización del Estudio',
      subtitle: 'Personaliza cómo aparece tu estudio a los clientes y visitantes',
      resetTooltip: 'Restablecer a la configuración predeterminada',
      previewTooltip: 'Vista previa de personalización',
      saveChanges: 'Guardar Cambios',
      enableCustomization: 'Habilitar Personalización',
      enableDescription:
        'Cuando está habilitado, tu configuración personalizada se aplicará a la página del estudio',
      choosePersonality: 'Elegir Personalidad del Estudio',
      tabs: {
        layout: 'Diseño',
        theme: 'Tema',
        content: 'Contenido',
      },
      layout: {
        heroStyle: 'Estilo Hero',
        heroStyles: {
          fullscreen: 'Pantalla Completa',
          banner: 'Banner',
          split: 'Dividido',
          minimal: 'Minimal',
        },
        logoPosition: 'Posición del Logo',
        logoPositions: {
          overlayLeft: 'Superposición Izquierda',
          center: 'Centro',
          above: 'Arriba',
          side: 'Lado',
        },
        ctaPosition: 'Posición de la Llamada a la Acción',
        ctaPositions: {
          hero: 'En Hero',
          below: 'Debajo de Hero',
          floating: 'Flotante',
          multiple: 'Múltiples Posiciones',
        },
        sectionOrder: 'Orden de las Secciones',
        sectionOrderDescription:
          'El orden en que aparecen las secciones en la página de tu estudio',
      },
    },
    theme: {
      title: 'Tema del Estudio',
      subtitle:
        'Gestiona la identidad visual de tu estudio con logo e imágenes de portada personalizados',
      logoSection: {
        title: 'Logo del Estudio',
        description: 'Sube el logo de tu estudio. Tamaño recomendado: 256x256px, máx 2MB',
        changeLogo: 'Cambiar Logo',
        uploadLogo: 'Subir Logo',
        removeLogo: 'Eliminar Logo',
        clickToPreview: 'Haz clic para previsualizar',
      },
      coverSection: {
        title: 'Imagen de Portada',
        description:
          'Sube la imagen de portada de tu estudio. Tamaño recomendado: 1200x400px, máx 5MB',
        changeCoverImage: 'Cambiar Imagen de Portada',
        uploadCoverImage: 'Subir Imagen de Portada',
        removeCoverImage: 'Eliminar Imagen de Portada',
      },
      guidelines: {
        title: 'Directrices del Tema',
        logoRequirements: 'Requisitos del Logo',
        logoSpecs: {
          squareFormat: 'Formato cuadrado (proporción 1:1) recomendado',
          minMaxSize: 'Mínimo 256x256px, máximo 512x512px',
          format: 'Formato PNG o JPG',
          maxFileSize: 'Tamaño máximo de archivo: 2MB',
          transparentBg: 'Fondo transparente preferido para PNG',
        },
        coverRequirements: 'Requisitos de la Imagen de Portada',
        coverSpecs: {
          landscapeFormat: 'Formato horizontal (proporción 3:1) recomendado',
          minSize: 'Mínimo 1200x400px',
          format: 'Formato PNG o JPG',
          maxFileSize: 'Tamaño máximo de archivo: 5MB',
          highQuality: 'Las imágenes de alta calidad se muestran mejor',
        },
      },
      messages: {
        logoSizeError: 'El tamaño del archivo del logo debe ser menor a 2MB',
        coverSizeError: 'El tamaño del archivo de la imagen de portada debe ser menor a 5MB',
        invalidImageFile: 'Por favor selecciona un archivo de imagen válido',
        logoUpdated: '¡Logo actualizado con éxito!',
        logoUpdateFailed: 'Error al actualizar el logo',
        coverUpdated: '¡Imagen de portada actualizada con éxito!',
        coverUpdateFailed: 'Error al actualizar la imagen de portada',
        confirmRemoveLogo: '¿Estás seguro de que deseas eliminar el logo del estudio?',
        confirmRemoveCover: '¿Estás seguro de que deseas eliminar la imagen de portada?',
        logoRemoved: '¡Logo eliminado con éxito!',
        logoRemoveFailed: 'Error al eliminar el logo',
        coverRemoved: '¡Imagen de portada eliminada con éxito!',
        coverRemoveFailed: 'Error al eliminar la imagen de portada',
      },
      preview: {
        logoTitle: 'Vista Previa del Logo',
        coverTitle: 'Vista Previa de la Imagen de Portada',
        close: 'Cerrar',
      },
    },
    showcase: {
      title: 'Vitrina Musical',
      settings: {
        title: 'Configuración de Vitrina Musical',
        subtitle: 'Configura la vitrina musical de tu estudio para los clientes',
        saveSettings: 'Guardar Configuración',
        enableShowcase: 'Habilitar Vitrina Musical',
        enableDescription:
          'Cuando está habilitada, tu vitrina musical será visible para los clientes en el perfil de tu estudio',
        showcaseTitle: 'Título de la Vitrina',
        showcaseTitlePlaceholder: 'ej. Nuestras Últimas Producciones',
        showcaseDescription: 'Descripción de la Vitrina',
        showcaseDescriptionPlaceholder: 'Describe tu vitrina musical...',
      },
      tracks: {
        title: 'Pistas Musicales',
        subtitle: 'Agrega pistas musicales para mostrar el trabajo de tu estudio',
        addTrack: 'Agregar Pista',
        addFirstTrack: 'Agregar Primera Pista',
        editTrack: 'Editar Pista',
        noTracksYet: 'No se han agregado pistas aún. ¡Agrega tu primera pista para comenzar!',
        enableShowcaseFirst: 'Habilita la vitrina musical arriba para comenzar a agregar pistas',
        trackCount: 'Pistas Musicales ({{count}})',
        hidden: 'Oculta',
        by: 'por',
      },
      trackDialog: {
        addTitle: 'Agregar Pista',
        editTitle: 'Editar Pista',
        trackTitle: 'Título de la Pista *',
        trackTitlePlaceholder: 'Ingresa el título de la pista',
        artist: 'Artista',
        artistPlaceholder: 'Nombre del artista o banda',
        platform: 'Plataforma *',
        url: 'URL *',
        description: 'Descripción',
        descriptionPlaceholder: 'Descripción o notas opcionales sobre esta pista',
        cancel: 'Cancelar',
        add: 'Agregar',
        update: 'Actualizar',
        addTrackButton: 'Agregar Pista',
        updateTrackButton: 'Actualizar Pista',
      },
      platforms: {
        youtube: 'YouTube',
        spotify: 'Spotify',
        soundcloud: 'SoundCloud',
        apple_music: 'Apple Music',
        bandcamp: 'Bandcamp',
        other: 'Otro',
      },
      urlHints: {
        youtube: 'ej. https://www.youtube.com/watch?v=dQw4w9WgXcQ o https://youtu.be/dQw4w9WgXcQ',
        spotify: 'ej. https://open.spotify.com/track/4uLU6hMCjMI75M1A2tKUQC',
        soundcloud: 'ej. https://soundcloud.com/artista/nombre-pista',
        apple_music: 'ej. https://music.apple.com/us/album/nombre-cancion/id123456789?i=123456789',
        bandcamp: 'ej. https://artista.bandcamp.com/track/nombre-cancion',
        other: 'Ingresa cualquier URL de plataforma musical',
      },
      actions: {
        openLink: 'Abrir enlace',
        hideTrack: 'Ocultar pista',
        showTrack: 'Mostrar pista',
        editTrack: 'Editar pista',
        removeTrack: 'Eliminar pista',
      },
      messages: {
        settingsSaved: '¡Configuración de vitrina guardada con éxito!',
        settingsSaveFailed: 'Error al guardar la configuración de la vitrina',
        enterTitle: 'Por favor ingresa un título de pista',
        enterUrl: 'Por favor ingresa una URL de pista',
        invalidUrl: 'Formato de URL {{platform}} inválido',
        trackUpdated: '¡Pista actualizada con éxito!',
        trackAdded: '¡Pista agregada con éxito!',
        trackSaveFailed: 'Error al guardar la pista',
        confirmRemove: '¿Estás seguro de que deseas eliminar "{{title}}" de la vitrina?',
        trackRemoved: '¡Pista eliminada con éxito!',
        trackRemoveFailed: 'Error al eliminar la pista',
        trackHidden: '¡Pista ocultada con éxito!',
        trackShown: '¡Pista mostrada con éxito!',
        trackToggleFailed: 'Error al cambiar la visibilidad de la pista',
        tracksReordered: '¡Pistas reordenadas con éxito!',
        tracksReorderFailed: 'Error al reordenar las pistas',
      },
    },
    availability: {
      title: 'Disponibilidad del Estudio',
      subtitle:
        'Configura los horarios de trabajo de tu estudio, las franjas horarias de reserva y las reglas de disponibilidad',
      loading: 'Cargando configuración de disponibilidad...',
      loadError:
        'Error al cargar la configuración de disponibilidad. Por favor, actualiza la página.',
      tabs: {
        workingHours: 'Horarios de Trabajo',
        bookingRules: 'Reglas de Reserva',
        timeSlots: 'Franjas Horarias',
      },
      daysOfWeek: {
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
        sunday: 'Domingo',
      },
      workingHours: {
        title: 'Horario Semanal',
        description:
          'Establece los horarios de apertura de tu estudio para cada día de la semana. Habilita el modo 24 horas o establece horarios que cruzan la medianoche (ej. 22:00 a 06:00 del día siguiente)',
        startTime: 'Hora de Inicio',
        endTime: 'Hora de Fin',
        is24Hours: '24h',
        nextDay: 'día siguiente',
        crossMidnightSchedule: 'Horario que cruza medianoche:',
      },
      crossDayPolicy: {
        title: 'Política de Reservas Multi-Día',
        enableCrossDayBookings: 'Habilitar Reservas Multi-Día',
        enableDescription:
          'Permitir reservas que se extienden más allá de la medianoche (ej. 23:00 a 02:00)',
        maxCrossDayHours: 'Horas Máximas Multi-Día',
        maxCrossDayHoursHelp:
          'Número máximo de horas que una reserva puede extenderse a través de días',
        allowWeekendCrossover: 'Permitir Cruce de Fin de Semana',
        allowWeekendCrossoverHelp:
          'Permitir que las reservas crucen del fin de semana a días laborables o viceversa',
        requireSameDayStart: 'Requerir Inicio el Mismo Día',
        requireSameDayStartHelp: 'La reserva debe comenzar y terminar en el mismo día calendario',
      },
      bookingRules: {
        title: 'Configuración de Reservas',
        description: 'Configura las reglas y restricciones de reserva',
        advanceBookingDays: 'Días de Reserva Anticipada',
        advanceBookingDaysHelp: 'Cuántos días de anticipación pueden reservar los clientes',
        minBookingNotice: 'Aviso Mínimo (horas)',
        minBookingNoticeHelp: 'Horas mínimas antes de la reserva',
        maxBookingDuration: 'Duración Máxima de Sesión (minutos)',
        maxBookingDurationHelp: 'Duración máxima de la reserva',
        bufferTime: 'Tiempo de Descanso (minutos)',
        bufferTimeHelp: 'Tiempo de descanso entre reservas',
        autoApproveBookings: 'Aprobar automáticamente las reservas',
        autoApproveBookingsHelp:
          'Aprobar automáticamente las solicitudes de reserva sin revisión manual',
        allowBackToBackBookings: 'Permitir reservas consecutivas',
        allowBackToBackBookingsHelp: 'Permitir programar reservas consecutivas',
      },
      timeSlots: {
        title: 'Configuración de Franjas Horarias',
        description: 'Configura las franjas horarias e intervalos de reserva',
        timeSlotUnit: 'Unidad de Franja Horaria',
        timeSlotDuration: 'Duración Predeterminada de Franja (minutos)',
        timeSlotDurationHelp: 'Duración predeterminada de las franjas de reserva',
        info: 'Las franjas horarias se generarán en función de tus horarios de trabajo y la unidad de tiempo seleccionada. Los clientes pueden seleccionar entre las franjas disponibles al reservar.',
        units: {
          '15min': '15 minutos',
          '30min': '30 minutos',
          '1hr': '1 hora',
        },
      },
      validation: {
        advanceBookingDaysRequired: 'Los días de reserva anticipada son requeridos',
        minBookingNoticeRequired: 'El aviso mínimo de reserva es requerido',
        maxBookingDurationRequired: 'La duración máxima de reserva es requerida',
        timeSlotDurationRequired: 'La duración de la franja horaria es requerida',
        bufferTimeRequired: 'El tiempo de descanso es requerido',
      },
      actions: {
        reset: 'Restablecer',
        saveSettings: 'Guardar Configuración',
      },
      messages: {
        settingsSaved: '¡Configuración de disponibilidad guardada con éxito!',
        saveFailed: 'Ocurrió un error. Por favor, inténtalo de nuevo.',
      },
    },
    settings: {
      title: 'Configuración General',
      subtitle: 'Configura los ajustes y preferencias de tu estudio',
      tabs: {
        general: 'General',
        bookingRules: 'Reglas de Reserva',
        notifications: 'Notificaciones',
        pricingPayment: 'Precios y Pagos',
        studioBusiness: 'Negocio del Estudio',
      },
      general: {
        studioName: 'Nombre del Estudio',
        studioNameHelp: 'El nombre de tu estudio como se muestra a los clientes',
        emailAddress: 'Dirección de Correo Electrónico',
        emailAddressHelp: 'Correo electrónico principal de contacto para tu estudio',
        phoneNumber: 'Número de Teléfono',
        phoneNumberHelp: 'Número de teléfono principal de contacto',
        address: 'Dirección',
        addressHelp: 'Dirección física de tu estudio',
        description: 'Descripción',
        descriptionHelp: 'Breve descripción sobre tu estudio y servicios',
        saveButton: 'Guardar Configuración General',
        noLocationsFound: 'No se encontraron ubicaciones',
      },
      bookingRules: {
        title: 'Reglas de Reserva',
        description: 'Configura cómo los clientes pueden reservar tu estudio',
        requiresApproval: 'Requiere Aprobación',
        requiresApprovalHelp: 'Aprobar manualmente las reservas antes de la confirmación',
        autoApprove: 'Aprobar Automáticamente las Reservas',
        autoApproveHelp: 'Aprobar automáticamente las solicitudes de reserva sin revisión manual',
        cancellationPolicy: 'Política de Cancelación',
        cancellationPolicyHelp: 'Detalles de tu política de cancelación',
        cancellationWindow: 'Ventana de Cancelación (horas)',
        cancellationWindowHelp: 'Horas antes de la reserva para cancelación gratuita',
        depositRequired: 'Depósito Requerido',
        depositRequiredHelp: 'Requerir un depósito para confirmar las reservas',
        depositPercentage: 'Porcentaje del Depósito',
        depositPercentageHelp: 'Porcentaje del total requerido como depósito',
        minAdvanceBooking: 'Reserva Anticipada Mínima (horas)',
        minAdvanceBookingHelp: 'Horas mínimas de antelación para reservar',
        maxAdvanceBooking: 'Reserva Anticipada Máxima (días)',
        maxAdvanceBookingHelp: 'Días máximos de antelación para reservar',
        bufferTime: 'Tiempo de Preparación (minutos)',
        bufferTimeHelp: 'Tiempo entre reservas para preparación',
        minBookingDuration: 'Duración Mínima de Reserva (minutos)',
        minBookingDurationHelp: 'Duración mínima permitida para una sesión de reserva única',
        maxBookingDuration: 'Duración Máxima de Reserva (minutos)',
        maxBookingDurationHelp: 'Duración máxima permitida para una sesión de reserva única',
        bookingSpacingTitle: 'Espaciado y Aprobación de Reservas',
        allowBackToBack: 'Permitir Reservas Consecutivas',
        allowBackToBackHelp:
          'Permitir que las reservas comiencen inmediatamente después de que termine la anterior',
        saveButton: 'Guardar Reglas de Reserva',
        saveSuccess: 'Reglas de reserva guardadas con éxito',
        saveFailed: 'Error al guardar las reglas de reserva',
      },
      paymentSettings: {
        title: 'Configuración de Pagos',
        subtitle: 'Configura cómo se cobran los pagos por las reservas',
        paymentMode: 'Modo de Pago',
        paymentModeRequired: 'El modo de pago es obligatorio',
        invalidPaymentMode: 'Modo de pago no válido',

        // Payment Modes
        manualMode: 'Confirmación Manual (Sin Pago Requerido)',
        manualModeDescription:
          'Las reservas se confirman sin pago. El propietario confirma manualmente.',
        fullMode: 'Pago Completo para Confirmar Reserva',
        fullModeDescription:
          'El cliente debe pagar el 100% por adelantado para confirmar la reserva.',
        depositMode: 'Pago de Depósito',
        depositModeDescription:
          'El cliente paga un porcentaje de depósito. El saldo restante se paga después.',
        holdMode: 'Retención de Pago (Pre-autorización)',
        holdModeDescription:
          'Colocar una retención en el método de pago del cliente. Cobrar después de que el propietario confirme la reserva.',

        // Deposit Settings
        depositConfiguration: 'Configuración de Depósito',
        depositConfigurationHelp:
          'Configurar porcentaje de depósito y restricciones opcionales de reserva anticipada',
        depositPercentage: 'Porcentaje de Depósito',
        depositPercentageHelp: 'Porcentaje del precio total requerido como depósito (0-100%)',
        depositPercentageMin: 'El porcentaje de depósito debe ser al menos 0%',
        depositPercentageMax: 'El porcentaje de depósito no puede exceder 100%',
        depositPercentageRequired:
          'El porcentaje de depósito es obligatorio para el modo de depósito',

        restrictDepositToAdvanceDays: 'Restringir Depósito a Reservas Anticipadas',
        restrictDepositToAdvanceDaysHelp:
          'Solo requerir depósito para reservas hechas con X días de antelación',
        depositOnlyForAdvanceDays: 'Depósito Requerido para Días de Antelación',
        depositOnlyForAdvanceDaysHelp:
          'Requerir depósito solo para reservas hechas con esta cantidad de días de antelación',
        depositOnlyForAdvanceDaysMin: 'Los días deben ser 0 o mayor',
        depositOnlyForAdvanceDaysRequired: 'Por favor especifica el número de días de antelación',

        // Payment Hold
        paymentHoldTitle: 'Retención de Autorización de Pago',
        paymentHoldDescription:
          'Se colocará una retención de pre-autorización en el método de pago del cliente. El monto no se cobrará hasta que confirmes manualmente la reserva. La retención típicamente expira después de 7 días si no se confirma.',

        // Payment Methods
        acceptedMethodsTitle: 'Métodos de Pago Aceptados',
        acceptedMethodsSubtitle: 'Selecciona qué métodos de pago aceptas',
        atLeastOneMethodRequired:
          'Al menos un método de pago debe ser seleccionado cuando se requiere pago',

        acceptCash: 'Efectivo',
        acceptCashHelp: 'Aceptar pagos en efectivo en el lugar',
        acceptCard: 'Tarjeta (En el lugar)',
        acceptCardHelp: 'Aceptar pagos con tarjeta en el lugar',
        acceptOnlinePayment: 'Pago en Línea',
        acceptOnlinePaymentHelp: 'Aceptar pagos en línea vía Stripe',

        // Stripe
        stripeIntegrationTitle: 'Integración de Stripe Requerida',
        stripeIntegrationDescription:
          'Para aceptar pagos en línea, necesitas conectar tu cuenta de Stripe. Contacta al soporte para configurar la integración de Stripe Connect.',
        stripeAccountIdRequired: 'El ID de cuenta de Stripe es obligatorio para pagos en línea',

        // Messages
        saveButton: 'Guardar Configuración de Pagos',
        saveSuccess: 'Configuración de pagos guardada con éxito',
        saveFailed: 'Error al guardar la configuración de pagos',
        applyToNewBookings:
          'La configuración de pagos se aplicará a todas las nuevas reservas. Las reservas existentes permanecen sin cambios.',

        // Days
        days: 'días',
      },
      notifications: {
        title: 'Configuración de Notificaciones',
        description: 'Gestiona cómo tú y tus clientes reciben notificaciones',
        emailNotifications: 'Notificaciones por Correo Electrónico',
        smsNotifications: 'SMS Notifications',
        emailNotificationsHelp: 'Habilitar notificaciones por correo electrónico',
        smsNotificationsHelp: 'Recibir notificaciones por SMS',
        whatsappNotifications: 'Notificaciones de WhatsApp',
        whatsappNotificationsHelp: 'Habilitar notificaciones de WhatsApp',
        customerNotifications: 'Notificaciones de Clientes',
        notifyOnBooking: 'Notificar en Nueva Reserva',
        notifyOnBookingHelp: 'Enviar notificación al cliente cuando se crea una reserva',
        notifyOnStatusChange: 'Notificar en Cambio de Estado',
        notifyOnStatusChangeHelp: 'Notificar al cliente cuando cambia el estado de la reserva',
        notifyBeforeSession: 'Recordatorio Antes de la Sesión',
        notifyBeforeSessionHelp: 'Enviar un recordatorio antes de la sesión programada',
        ownerNotifications: 'Notificaciones del Propietario',
        notifyOwnerOnBooking: 'Notificar al Propietario de Nuevas Reservas',
        notifyOwnerOnBookingHelp:
          'Alertar al propietario del estudio sobre nuevas solicitudes de reserva',
        notifyOwnerOnCancellation: 'Notificar al Propietario de Cancelaciones',
        notifyOwnerOnCancellationHelp:
          'Alertar al propietario del estudio sobre cancelaciones de reserva',
      },
      studioBusiness: {
        title: 'Configuración de Negocio del Estudio',
        description: 'Gestiona la visibilidad pública y la configuración de negocio de tu estudio',
        isPublic: 'Estudio Público',
        isPublicHelp: 'Hacer el estudio visible en búsquedas y listados públicos',
        acceptBookings: 'Acepta Reservas',
        acceptBookingsOn: 'Tu estudio está aceptando nuevas solicitudes de reserva',
        acceptBookingsOff: 'Las nuevas reservas están temporalmente deshabilitadas',
        acceptsBookings: 'Acepta Reservas',
        acceptsBookingsHelp: 'Aceptar nuevas solicitudes de reserva',
        musicStyles: 'Estilos Musicales',
        musicStylesHelp:
          'Selecciona los estilos musicales que tu estudio admite (mantén Ctrl/Cmd para selección múltiple)',
        country: 'País',
        currency: 'Moneda',
        timezone: 'Zona Horaria',
        language: 'Idioma',
        websiteUrl: 'URL del Sitio Web',
        websiteUrlHelp: 'Sitio web de tu estudio (opcional)',
        socialMedia: 'Redes Sociales',
        musicStylePlaceholder: 'Agregar estilo o género musical (ej., Rock, Jazz, Hip Hop)',
        noMusicStyles:
          'Aún no se han agregado estilos musicales. Agrega algunos para ayudar a los clientes a encontrar tu estudio.',
        saveButton: 'Guardar Configuración de Negocio del Estudio',
        saveSuccess: 'Configuración de negocio del estudio guardada con éxito',
        saveFailed: 'Error al guardar la configuración de negocio del estudio',
        socialMediaHelp: 'Enlaces a tus perfiles de redes sociales',
      },
      validation: {
        nameRequired: 'El nombre del estudio es obligatorio',
        emailRequired: 'La dirección de correo electrónico es obligatoria',
        emailInvalid: 'Dirección de correo electrónico no válida',
        phoneRequired: 'El número de teléfono es obligatorio',
        addressRequired: 'La dirección es obligatoria',
      },
      messages: {
        settingsSaved: '¡Configuración guardada con éxito!',
        saveFailed: 'Error al guardar la configuración',
        notificationsSaved: '¡Configuración de notificaciones guardada con éxito!',
        notificationsSaveFailed: 'Error al guardar la configuración de notificaciones',
      },
    },
  },
  method: 'Método',

  manual: 'Manual',
  full: 'Completo',
  deposit: 'Depósito',
  hold: 'Retención',

  // Import modular translations
  ...globalDashboardEs,
  ...privacyEs,
  ...analyticsEs,
  ...stripeConnectEs,
};

export default es;
